/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
export const i18nDeDe = {
    false: "Nein",
    true: "Ja",
    back: 'Zurück',
    continue: 'Weiter',
    type: 'Typ',
    edit: 'Bearbeiten',
    globalShortcuts: 'Globale Shortcuts',
    notification: 'Benachrichtigungen',
    timeClock: 'Stempeluhr',
    reportBug: "Fehler melden",
    start: 'Start',
    pause: 'Pause',
    stop: 'Stop',
    CTRLM: 'STRG + M',
    CTRLO: 'STRG + O',
    CTRLB: 'STRG + B',
    ImportCsv: "CSV importieren",
    ExportCsv: "CSV exportieren",
    ImportExcel: "Excel importieren",
    ExportExcel: "Excel exportieren",
    Create: "Erstellen",
    Show: "Anzeigen",
    Edit: "Bearbeiten",
    Copy: "Kopieren",
    Delete: "Löschen",
    Close: "Schließen",
    Cancel: "Abbrechen",
    Update: "Aktualisieren",
    Redo: "Wiederholen",
    Undo: "Rückgängig",
    Reset: "Zurücksetzen",
    attachment: 'Anhang',
    onThisPage: 'Auf dieser Seite',
    accountCompanyInfoHeader: 'Firmendaten',
    accountCompanyAddCompany: 'Neue Firma Erstellen',
    accountEmployeeGroupConfirmed: 'Verifizierte Nutzer',
    accountEmployeeGroupNotConfirmed: 'Nicht verifizierte Nutzer',
    accountEmployeeAddUser: 'Neuen Nutzer hinzufügen',
    accountGeneralHeader: 'Accountdaten',
    accountPersonalInfoHeader: 'Persönliche Daten',
    accountPersonalSignature: "Signatur",
    accountPersonalUploadSignature: "Unterschrift hochladen",
    companyDetailsUploadLogo: "Logo hochladen",
    accountSaveBottomBar: 'Änderung speichern',
    accountNewDepartment: 'Neue Abteilung',
    accountConfirmationHeader: 'Account Erfolgreich Bestätigt ',
    accountConfirmationContent: 'Es wurde eine Bestätigungsmail versendet. Bitte bestätigen Sie Ihren Account.',
    accountPwResetConfirmation: 'Es wurde eine Email versendet. Bitte bestätigen Sie diese.',
    accountConfirmationSetNewPasswordHeader: 'Bitte geben sie ein Passwort für Ihren neuen Account ein:',
    accountConfirmationContinueToHome: 'Weiter zum Kundenportal',
    userIsVerifiedHint: 'E-Mail-Adresse bestätigt',
    userHasSignatureHint: 'Unterschrift digital hinterlegt',
    addComingSoon: 'Feature to update screenshots coming soon!',
    addFeatureDesc: 'Feature-Beschreibung',
    addFeatureHeader: '{{index}}. Feature:',
    addFeatureTitle: 'Feature-Titel',
    addFinish: 'Erstelle {{prodName}}',
    addFinishEdit: 'Aktualisiere {{prodName}}',
    addLongDesc: 'Ausführliche Beschreibung für {{langCode}}',
    addName: 'Name des neuen Produktes',
    productCostTrendYear: 'Jahr',
    productCostTrendCosts: 'Kosten in €',
    addNameEdit: 'Name des Produktes',
    addPaymentInterval: 'Zahlungsinterval (in Monaten)',
    addPricingFeature: 'Abrechnungskosten / Feature',
    addProductDiscounts: "Rabatte / Ab Lizenz",
    addProductDiscountsEnabled: "Rabattierung aktiviert",
    addPrice: 'Preis',
    addProductImage: 'Produktbild auswählen',
    addProductUniversalScreenshot: 'Sprach-Unabhänige Bilder',
    selectLanguage: "Sprache Wählen",
    addShortDesc: 'Kurzbeschreibung für {{langCode}}',
    addStepFeature: 'Features',
    addStepGeneral: 'Generelle Informationen',
    addStepScreenshot: 'Screenshots',
    addAttachments: 'Anhänge',
    addStepLicenseAgreements: 'Lizenzvereinbarungen',
    addStepPricing: 'Preise & Rabatte',
    pricingFeatures: 'Feature-Übersicht',
    addressAddNewAddress: 'Neue Adresse hinzufügen',
    addressEditAddress: 'Adresse bearbeiten',
    addressCreateHelpTextPre: "Hier können Sie Ihre Firmenadresse einsehen oder ändern. Adressen werden im meistens als Lieferadressen und/oder Rechnungsadressen verwendet.",
    addressCreateHelpTextAfter: "Nach dem Speichern wird die Adresse sofort in Übersicht aktualisiert.",
    addressFederalState: 'Bundesland',
    addressLand: 'Land',
    addressNumber: 'Hausnummer',
    addressPageHeader: 'Firmenaddressen',
    addressStreet: 'Straßenname',
    addressTown: 'Stadt',
    addressType: 'Addresstyp',
    addressZip: 'Postleitzahl',
    authConfirmationHeader: 'Bestätigung',
    authConfirmationInfoTextOpen: 'Zur Bestätigung Ihres Accounts wurde Ihnen eine E-Mail an die folgende Addresse geschickt {{email}}.',
    authConfirmationSuccess: 'Herzlichen Glückwunsch! \n Ihr Account wurde erfolgreich bestätigt',
    checkoutAddress: 'Wählen Sie eine Addresse aus',
    checkoutAutoRenewMulti: 'Aktualisiert die Lizenz automatisch alle {{interval}} Monate',
    checkoutAutoRenewSingle: 'Aktualisiert die Lizenz automatisch jeden Monat',
    checkoutCredit: 'Kreditkarte',
    checkoutDebit: 'Lastschrift',
    checkoutMail: 'E-Mail-Anfrage',
    checkoutOrder: 'Auftragsdetails',
    checkoutOwnedBy: 'Verwaltet von {{owner}}',
    checkoutPayPal: 'PayPal',
    checkoutPayment: 'Wählen Sie eine Bankverbindung aus',
    checkoutRouteToNewAddress: 'Nicht die richtige Addresse vorhanden? \n Klicken Sie hier um eine neue hinzuzufügen.',
    checkoutRouteToNewBank: 'Nicht die richtige Bankverbindung vorhanden? \n Klicken Sie hier um eine neue hinzuzufügen.',
    checkoutValueContainer: '{{amount}} €',
    checkoutOrderDetailsHeader: 'Bestelldetails',
    checkoutVisa: 'Visa',
    checkoutToolTip: '{{method}} in Kürze verfügbar',
    ComboBoxValueEmpty: '--leer--',
    confirmationCancelText: 'Sind Sie sicher das Sie den Vorgang abbrechen Möchten?',
    confirmationNo: 'Nein',
    confirmationSureText: 'Sind Sie sicher?',
    confirmationYes: 'Ja',
    detailTabDownload: 'Downloads',
    detailTabFeatures: 'Features',
    detailTabNews: 'Nachrichten',
    detailTabReleases: 'Releases',
    detailTabPricing: 'Preise',
    detailTabDocuments: 'Dokumente',
    detailTabNoDocuments: 'Keine Lizenzdokumente vorhanden',
    detailTabDocumentsLicenses: 'Lizenzen',
    detailTabDocumentsDocuments: 'Dokumente',
    departmentHeader: 'Abteilungen',
    departmentAlreadyExists: 'Department existiert bereits',
    employeeAccountCreate: 'Neuen Mitarbeiter hinzufügen',
    employeeAccountUpdate: 'Mitarbeiter bearbeiten',
    employeeBirthdate: 'Geburtstag',
    employeeCountry: 'Geburtsort',
    employeeDegree: 'Akademischer Titel',
    employeeDepartment: 'Abteilung',
    employeeEmail: 'E-Mail',
    employeeVerified: "Verifiziert",
    employeeLastPasswordChange: "Letzte Passwortänderung",
    employeeGivenName: 'Vorname',
    employeeLastName: 'Nachname',
    employeeName: 'Name',
    employeeNoPhone: 'Keine Telefonummer angegeben',
    employeeNoDepartment: 'Kein Department vergeben',
    employeeNoBirthplace: 'Keine Geburtsort angegeben',
    employeePageHeader: 'Mitarbeiterverwaltung',
    employeePhone: 'Telefonnummer',
    employeeRole: 'Berechtigung',
    employeeRoles: 'Berechtigungen',
    employeeSalutations: 'Anrede',
    employeeSalutationsFemale: 'Frau',
    employeeSalutationsMale: 'Herr',
    employeeSalutationsOther: 'Divers',
    employeeUsername: 'Benutzername',
    generalRequireTasks: "Tasks verpflichtend",
    generalTitle: "Titel",
    general_to: "bis",
    generalSelectedTab: "Tab",
    generalRoute: "Frontend-Route",
    generalDetails: 'Details',
    generalSecurity: "Passwort & Sicherheit",
    generalFor: "für",
    generalAll:'Alle',
    generalReset: "Zurücksetzen",
    generalRole: "Rolle",
    generalRoles: "Rollen",
    generalAlias: 'Aliasse',
    generalManagement: 'Management',
    generalRemove: 'Entfernen',
    generalArchive: 'Archivieren',
    generalEdit: 'Bearbeiten',
    generalChangesSaved: 'Ihre Änderungen wurden erfolgreich gespeichert',
    generalError: "Fehler",
    generalSuccess: "Erfolg",
    generalBack: 'Zurück',
    generalCancel: 'Abbrechen',
    generalCompanyManagingDirectors: 'Geschäftsführung',
    generalCompanyName: 'Firma',
    generalCount: "Anzahl",
    generalDescription: 'Beschreibung',
    generalFileUploadChoseMulti: 'Dateien auswählen',
    generalFileUploadChoseSingle: 'Datei auswählen',
    generalGroupBy: 'Gruppieren nach',
    generalName: 'Name',
    generalMutability: 'Schreibrechte',
    generalExpiryDate: 'Gültig bis',
    generalId: "Id",
    generalNext: 'Weiter',
    generalPassword: 'Passwort',
    generalNewPassword: "Neues Passwort",
    generalRegister: 'Registrieren',
    generalSave: 'Speichern',
    generalSearch: 'Suchen',
    generalSortBy: 'Sortieren nach:',
    generalUpload: 'Hochladen',
    generalProduct: 'Produkt',
    generalProductId: 'Produkt-Id',
    generalAvailability: 'Verfügbarkeiten',
    generalCreate: 'Erstellen',
    generalCreated: 'Erstellt',
    generalImport: 'Import',
    generalImportCsv: 'Import CSV',
    generalImportExcel: 'Import Excel',
    generalExport: "Export",
    generalExportCsv: "Export CSV",
    generalExportExcel: "Export Excel",
    generalRegexPattern: "Regulärer ausdruck",
    generalRegexCaptureGroup: "Regex Gruppe",
    generalAccountInfos: "Accountinformationen",
    generalGroupName: "Gruppe",
    generalOrderIdShort: "Bestellnr.",
    generalOrderId: "Bestellnummer",
    generalReceiptNoShort: "Rechnungsnr.",
    generalReceiptNo: "Rechnungsnummer",
    generalGroupAdd: "Gruppe Hinzufügen",
    generalBuyer: "Käufer",
    generalPieces: "Stück",
    generalHours: "Stunden",
    generalPosition: "Position",
    generalPositions: "Positionen",
    generalReceiver: "Empfänger",
    generalSent: "Gesendet",
    generalType: "Typ",
    generalReadAll: "Alle gelesen",
    generalClearAll: "Leeren",
    homeNews: 'Neuigkeiten',
    homeQuickAccess: 'Schnellzugriff',
    loginChangePassword: 'Passwort ändern',
    loginNewPassword: 'Neues Passwort',
    loginNoAccount: 'Noch kein Account?',
    accountProfile: "Profil",
    administration: "Administration",
    adminAvailableBackups: "Verfügbare Backups",
    adminRestoreHelpText: "Mit dieser Funktion können die Applikationsdaten aus einem Backup wiederhergestellt werden. Stellen Sie sicher, dass das Backup aktuell ist und von der gleichen Instanz stammt. Beachten Sie, dass alle Applikationsdaten durch die Daten aus dem Backup ersetzt werden.",
    adminBackupHelpText: "Mit dieser Funktion lässt sich die gesamte Applikation sichern. Achten Sie bitte darauf, dass der Pfad 'BackupPath' richtig konfiguriert wurde und der Datenbank Benutzer die nötigen Rechte hat, um ein Backup auszuführen.",
    adminBackupCreatedText: "Erfolgreich erstelltes Backup: {{fileName}} mit einer Größe von {{size}} MB",
    adminCreateBackup: "Backup erstellen",
    generalBackup: "Backup",
    adminRestore: "Aus backup herstellen (Coming soon)",
    loginOneTimePassword: 'Einmalpasswort',
    loginSignIn: 'Anmelden',
    loginInsteadHint: 'Zurück zur Anmeldung',
    loginSignUp: 'Registrieren Sie sich hier!',
    loginOutOfDate: 'Ihr Passwort Scheint abgelaufen zu sein!\nGeben sie bitte ein neues ein',
    newsAddNews: 'Neue Nachricht hinzufügen',
    newsImage: 'Anzeigebild',
    newsProductRelation: 'Produktbeziehungen',
    newsAttachments: "Anhänge",
    newsTranslations: "Übersetzungen",
    managementAboutProd: 'Über die Software:',
    managementAssignmentError: 'Nutzerlimit für diese Lizenz erreicht',
    managementAutoRenewal: 'Automatische Erneuerung:',
    managementBoughtLicences: 'Erworbene Aktivierungen:',
    managementDividerFirstname: 'Vornamen die mit {{sortedKey}} anfangen',
    managementDividerLastname: 'Nachnamen die mit {{sortedKey}} anfangen',
    managementDividerLicence: 'Nutzer mit {{sortedKey}} Lizenz',
    managementDividerNoLicence: 'Nutzer ohne Lizenz',
    managementDividerRole: 'Nutzer mit {{sortedKey}} Berechtigung',
    managementDividerUsername: 'Nutzernamen die mit {{sortedKey}} anfangen',
    managementEditAssignment: 'Lizenz zuweisen',
    managementGroup1None: 'Nicht Gruppieren',
    managementGroup2Licences: 'Lizenz',
    managementGroup6Roles: 'Nutzerrolle',
    managementHeader: 'Erworbene Lizenzen',
    managementLicenceFrom: 'Lizenz erworben am:',
    managementLicenceId: 'Lizenz-ID:',
    managementLicenceTo: 'Lizenz gültig bis:',
    managementMiniFabAdd: 'Vergibt dem Nutzer die Lizenz',
    managementMiniFabRemove: 'Enzieht dem Nutzer die Lizenz',
    managementNewLicence: 'Weitere Lizenzen bestellen',
    managementNextRenewal: 'Nächste Erneuerung:',
    managementNoLicenceOwned: 'Diesem Nutzer sind keine Lizenzen zugewiesen',
    managementNoProductsBooked: 'Sie haben keine Lizenz zu unseren Produkten\nKlicken Sie hier um zur Produkt-Seite weitergeleitet zu werden',
    managementOwnedLicenceHeader: 'Lizenzen, die dem Nutzer zugewiesen sind',
    managementRemainingActivations: 'Verbleibene Aktivierungen:',
    managementProductActive: 'Produkt aktiviert:',
    managementIsDemo: 'Demo Version:',
    managementToOverview: 'Zurück zur Übersicht',
    managementToProduct: 'Zum Produkt',
    managementUserWithLicence: 'Nutzer mit <b>{{product}}</b> Lizenz:',
    managementUserWithoutLicence: 'Nutzer ohne <b>{{product}}</b> Lizenz',
    licenseOrderConfirmation: "Ihre Lizenz wurde erfolgreich bestellt!",
    licenseCostPerUserYear: "pro Benutzer",
    licenseDiscountPerAmount: "Ab <b>{{amount}}</b> Lizenzen:",
    licenseDiscount: "Rabatte",
    licenseDiscountSingular: "Rabatt",
    licenseDiscountInPercent: "Rabatt in %",
    licenseSavedHint: "Sie sparen",
    licenseDiscountOldLicenseHint: "Mögliche zusätzliche Rabatte auf bereits existierende Lizenzen (z.B. Mengenrabatte) werden nach Bestellung automatisch angewandt. Diese werden nur in der aktuellen Kalkulation nicht berücksichtigt.",
    licenseDiscountHint: "Der Lizenzrabatt gilt für alle erworbenen Lizenzen sowie Features, unabhängig vom Zeitpunkt der Bestellung",
    licenseCostPerUserFirstYear: "erstes Jahr",
    licenseCostPerUserSecondYear: "zweites Jahr",
    licenseCostPerUserThirdYear: "drittes und folgende Jahre",
    licenseCostMwst: 'MwSt.',
    licenseCostInklMwst: 'inkl. MwSt.',
    licenseOrderDemo: 'Demo Version bestellen',
    managementProductNoUser: 'Noch kein nutzer Zugewiesen',
    paymentAccountOwner: 'Kontoinhaber',
    paymentAddNewBank: 'Neue Bankverbindung hinzufügen',
    paymentBankName: 'Name der Bank',
    paymentBic: 'BIC',
    paymentIban: 'IBAN',
    paymentPageHeader: 'Bankdaten',
    productSateDraft: "Entwurf",
    productSateAvailable: "Verföffentlicht",
    productSateArchived: "Archiviert",
    productDescriptions: 'Produktbeschreibungen',
    productChoseState: "Wählen Sie den Status aus",
    productManagementSectionText: "Diese Sektion beinhaltet management funktionen, die sich global auf das Produkt auswirken. Diese Funktionen sollten bedacht und mit Umsicht ausgeführt werden, da sich die Aktionen möglicherweise auf das laufende Produktgeschäft auswirken.",
    productLicenceSectionText: "Als Administrator haben Sie die Möglichkeit, Lizenzvereinbarungen für jedes Produkt hochzuladen. Diese Lizenzvereinbarungen werden im Downloadbereich des jeweiligen Produkts angezeigt. Sie dienen dazu, dem Endnutzer klare Informationen über die Nutzungsbedingungen und Einschränkungen des Produkts zu bieten. Durch das Hochladen dieser Vereinbarungen können Sie sicherstellen, dass Ihre Kunden stets gut informiert sind und die Produkte gemäß den festgelegten Richtlinien verwenden.",
    productDeleteHintText: "Löschen Sie dieses Produkt, ist das Produkt nicht mehr für Kunden sichtbar und kann auch nicht mehr bestellt werden. Lediglich laufende Verträge von bestehenden Kuden bleiben erhalten.",
    productArchiveHintText: "Archivieren Sie dieses Produkt, ist es nicht mehr für Kunden sichtbar. Die letzte Änderung wird vorgehalten und bei bedarf können Sie das Produkt wiederherstellen.",
    productPricingAndDiscountSectionText: "In diesem Abschnitt haben Sie die Möglichkeit Preise und Rabatte für Ihr Produkt zu bearbeiten. Diese werden Sofort wirksam. Die Änderungen werden nicht für existente Kunden-Verträge wirksam, sondern erst nach der nächsten Bestellung bzw. Nachbestellung des Kunden.",
    productFeatureSectionText: "Hier können Sie Ihr Produkt anhand von Features für den Kunden beschreiben und in Vorbereitung auf das folgende Preismodell detailliert anpassen. Änderungen am Feature set für bestehende Produkte wirken sich nicht auf bestehende Produkte von Kudnen aus. Werden hier Änderungen vorgenommen, sind diese erst für zukünftige Bestellungen wirksam.",
    productScreenshotsSectionText: "Produktbilder sind für Ihre Kunden das A & O. In dieser Section können Sie diese bearbeiten, löschen oder neue hinzufügen. Beachten Sie, dass Sie hier qualitativ hochwertige und aussagekräftige Bilder nutzen, sodass der Kunde den Fokuks auf die wesentlichen Produktfunktionen behält.",
    productAlreadyBoughtLicences: 'Anzahl gekaufter Lizenzen',
    productAvailableVersions: 'Verfügbare Downloads:',
    productBuyLicence: 'Lizenz erwerben',
    productChooseEmpty: 'Kein Produkt',
    productChooseProduct: 'Wählen Sie ein Produkt aus',
    productChooseVersion: 'Wählen Sie eine Version',
    productMainHeader: 'Unsere Produkte',
    productPaymentInterval: 'Zahlungsintervall',
    productPriceOfLicenceAmount: 'Gesamtpreis der aktuellen Anfrage',
    productPricePerLicence: 'Preis pro Lizenz',
    productProcureAmount: 'Anzahl der angefragten Lizenzen',
    productRelease: 'Neue Produktversion',
    productSearch: 'Suche Nutzer',
    productAvailableFrom: 'Verfügbar von',
    productAvailableTo: 'Verfügbar bis',
    productFeatureOrderableInDemo: 'Bestellbar in Demo-Version',
    productFeatureOrderableInProd: 'Bestellbar in Vollversion',
    newsMainHeader: 'Neuigkeiten',
    newsSubHeader: "Diese Seite ermöglicht es Mitarbeitern und Administratoren, aktuelle Neuigkeiten zu verwalten. Bitte beachten Sie, dass Produktinformationen nur dann relevant sind, wenn bestimmte Neuigkeiten sich auf ein spezifisches Produkt beziehen und nicht auf allgemeine Informationen. Das Veröffentlichungsdatum ist ausschließlich erforderlich, wenn ein Eintrag zu einem zukünftigen Zeitpunkt veröffentlicht werden soll.",
    newsDraft: "Entwurf",
    productSendRequest: 'Anfrage abschicken',
    productOrderAcceptTermsAndCondtionsStart: 'Ich akzeptiere die Bedingungen der',
    productOrderAcceptTermsAndCondtionsEnd: 'Lizenzvereinbarung',
    registerConfirmPassword: 'Passwort (Bestätigung)',
    registerHeader: 'Registrierung',
    releaseDialogPlatform: 'Platform',
    releaseDialogRelease: 'Release auswählen',
    releaseDialogVersion: 'Version',
    productReleaseDate: "Veröffentlicht am",
    productReleaseSize: "Dateigröße",
    sidebarAccount: 'Account',
    sidebarAccountAddresses: 'Adressen',
    sidebarAccountCompany: 'Firma',
    sidebarAccountEmployees: 'Mitarbeiter',
    sidebarAccountGeneral: 'Allgemein',
    sidebarAccountPayment: 'Bankdaten',
    sidebarHome: 'Startseite',
    sidebarLicenceManagement: 'Lizenzen',
    sidebarProducts: 'Produkte',
    userAddNewUser: 'Neuen Nutzer hinzufügen',
    userInfo: 'Nutzerinfo',
    validationCompareEmail: 'Email Adressen stimmen nicht überein',
    validationComparePassword: 'Passwörter stimmen nicht überein',
    validationErrorTypeDecimal: 'Entspricht nicht der geforderten dezimal-Schreibweise',
    validationErrorTypeUpperCase: 'Muss Großbuchstaben enthalten',
    validationErrorTypeNumbers: 'Muss Zahlen enthalten',
    validationErrorTypeLowerCase: 'Muss Kleinbuchstaben enthalten',
    validationErrorTypeNoUpperCase: 'Keine Großbuchstaben erlaubt',
    validationErrorTypeNoNumbers: 'Keine Nummern erlaubt',
    validationErrorTypeNoLowerCase: 'Keine Kleinbuchstaben erlaubt.',
    validationErrorTypeNoSpecialChar: 'Keine Sonderzeichen erlaubt',
    validationErrorTypeNoWhiteSpace: 'Darf kein Leerzeichen enthalten',
    validationErrorTypeSpecialChar: 'Muss Sonderzeichen enthalten',
    validationErrorTypeIban: 'Kein zulässiges Iban Format',
    validationErrorTypeFailedChecksum: 'Iban hat eine Invalide Checksum',
    validationErrorTypeIbanLength: 'Iban ist zu kurz',
    validationInvalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse an',
    validationIcloudInvalid: 'ICloud E-Mail Adressen werden nicht unterstützt',
    validationInvalidMaxLength: 'Darf nicht mehr als {{length}} Zeichen lang sein!',
    validationInvalidMinLength: 'Muss mehr als {{length}} Zeichen haben!',
    validationInvalidPassword: 'Passwort muss: eine Nummer, einen Großbuchstaben, ein Kleinbuchstaben und ein Sonderzeichen enthalten. Die Mindestlänge liegt bei 8 Zeichen',
    validationInvalidPattern: 'Input soll das folgende format haben: {{pattern}}',
    validationRequired: '{{label}} darf nicht leer sein',
    validationErrorTypePhone: "Bitte geben Sie eine gültige Telefonnummer ein",
    validationErrorTypeUrl: "Bitte geben Sie eine gültige URL ein (muss mit http:// oder https:// beginnen)",
    validationErrorTypeBic: "Bitte geben Sie eine gültige BIC/SWIFT-Nummer ein",
    validationErrorTypePattern: "Ungültiges Format",
    validation_invalidTimeInput:'Eine oder Mehrere Zeitangaben sind nicht Zulässig',
    passwordRecoverConfirmHeader: 'Neues Passwort Festlegen',
    passwordRecoverConfirmNewPassword: 'Neues Passwort',
    passwordRecoverConfirmNewPasswordCon: 'Passwort bestätigen',
    passwordChangeOld: 'Altes Passwort',
    passwordRecoverHeader: 'Passwort zurücksetzen',
    passwordRecoverDescription: 'Um Ihr Passwort zurückzusetzen geben Sie bitte Ihre E-Mail Adresse ein. Sobald Sie diese abschicken, erhalten Sie eine E-Mail mit einem Reset-Link.',
    generalSend: 'Abschicken',
    passwordForgotten: 'Passwort vergessen?',
    addNewsTitle: 'Nachrichten Titel',
    addNewsNewsText: 'Nachrichten Inhalt',
    newsChooseProduct: 'Wählen Sie das zugehörige Produkt aus',
    newsChooseType: "Wählen Sie den News Typ aus",
    newsReleaseDate: "Veröffentlichungsdatum",
    newsChooseProductVersion: 'Wählen Sie die zugehörige Produktversion aus',
    generalSetDefault: 'Als Standard festlegen',
    generalDefault: 'Standard',
    productExtendButtonRelease: 'Release hinzufügen',
    productExtendButtonNews: 'News hinzufügen',
    productExtendButtonProduct: 'Produkt bearbeiten',
    addressTypeDefault: 'Anschrift',
    addressTypeShipping: 'Lieferadresse',
    addressTypeBilling: 'Rechnungsadresse',

    // CRM TRANSLATION KEYS
    dialogHeaderContact: 'Kontaktdetails',
    inPerson: 'Persönlich',
    letter: 'Brief',
    fax: 'Fax',
    carrierPigeon: 'Brieftaube',
    addBusinessHours: 'Öffnungszeiten hinzufügen',
    addRelationType: 'Wähle ein Verbindung:',
    addRelationMinComm: 'Die Nachricht ist eine {{type}} auf:',
    addToDoTitle: 'Neuen ToDo erstellen',
    addToDoTask: 'Aufgabe',
    addToDoText: 'Beschreibung',
    generalWatcher: "Beobachter",
    addProjectDialogeOptionalInfos: 'Optionale Informationen',
    communicationEdit: 'Bearbeiten',
    communicationAddRelation: 'Zusammenhänge',
    communicationAddStatus: 'für den Status',
    communicationDelete: 'Entfernen',
    addCommunicationTitle: 'Neuer Eintrag',
    commDetailEdit: 'Eintrag Bearbeiten',
    commDetailDelete: 'Eintrag Entfernen',
    commDetailTitleInput: 'Titel',
    commDetailTextInput: 'Notizen',
    commDetailTypeInput: 'Nachrichtentyp',
    commDetailParent: 'Diese Nachricht ist eine Antwort auf:',
    commDetailRelationHeader: 'Antworten auf diese Nachricht',
    companyDisplayChangeCompany: 'Unternehmen ändern',
    companyDisplayLocalTime: 'Lokale Zeit',
    companyDisplayBusinessHours: 'Öffnungszeiten',
    companyDisplayContactPerson: 'Ansprechpartner',
    companyDisplayAddNewContact: 'Ansprechpartner hinzufügen',
    companyDisplayLinkNewTracker: 'Neuen Tracker starten',
    companyCreateHeader: 'Neue Firma erstellen',
    companyCreateSetTimeZone: 'Zeitzonen verschiebung (h):',
    companyCreateSetName: 'Firmenname',
    companyCreateSetOpeningTime: 'Öffnungszeiten',
    companyManagerSignatureMissing: 'Hinweis: Folgende Geschäftsführer haben noch keine gültige Unterschrift: ',
    companyManagerSignatureMissingSubText: 'Diese ist für ausgehende Rechnungen oder anderweitigen Schriftverkehr anzugeben.',
    companyTaxNumber: "Steuernummer",
    companySalesTaxNumber: "Umsatzsteuer Nr.",
    companyTaxOffice: "Zuständiges Finanzamt",
    companyCourtOffice: "Name Amtsgericht",
    companyCourtOfficeNr: "Handelsregister Nummer",
    companyProfitDetermination: "Art der Gewinnermittlung",
    companyFormOfAccounts: "Kontorahmen",
    companyWebsite: "Website",
    companyPhone: "Telefonnummer",
    contactDetailHeader: 'Kontaktdetail',
    contactCreateHeader: 'Erstelle einen neue Kontakt',
    confirmationTitle: 'Eintrag Löschen',
    confirmationText: 'Sind Sie sicher, dass Sie den Eintrag löschen wollen?',
    confirmationDeleteMultipleText: 'Sind Sie sicher, dass Sie die ausgewählten Einträge löschen wollen?',
    confirmationResetText: 'Sind Sie sicher, dass Sie alle Einträge zurücksetzen wollen?',
    dialogRelationMulti: 'Wähle Antworten aus',
    dialogRelationSingle: 'Wähle einen Parent aus',
    dialogRelationSetParent: 'setzte Nachricht als parent',
    dialogRelationSetAnswer: 'setze Nachrichten als antwort',
    filterByWorkflow: 'Nach Ablauf Filtern',
    filterByStatus: 'Nach Status Filtern',
    groupAdd: '',
    groupName: '',
    quickInputHead: 'Schnelldokumentierung',
    quickInputNewCompany: 'Neues Unternehmen erstellen',
    quickInputOldCompany: 'Vorhandes Unternehmen erweitern',
    quickInputTextTitle: 'Titel',
    quickInputText: 'Text',
    generalAdd: 'Hinzufügen',
    generalDate: 'Datum',
    generalCompany: 'Unternehmen',
    generalPronouns: 'Anrede',
    generalFirstName: 'Vorname',
    generalLastName: 'Nachname',
    generalEMail: 'E-Mail',
    generalPhone: 'Telefonnummer',
    generalLogin: 'Anmelden',
    generalContactPerson: 'Ansprechpartner',
    generalNote: 'Notiz',
    generalChooseWorkflow: 'Workflow',
    generalStartingStatus: 'Anfangs Status',
    generalUser: 'Nutzer',
    generalDelete: 'Löschen',
    generalUpdate: 'Aktualisieren',
    generalCurrency: '€',
    generalLock: "Sperren",
    generalUnlock: "Freischalten",
    generalRolesAndPermissions: "Rollen & Rechte",
    generalServerSettings: "Servereinstellungen",
    generalEnvironment: "Umgebungsvariablen",
    generalIntegrations: "Integrationen",
    generalVariablesSettings: "Variablen",
    generalDiagnostics: "Log & Diagnose",
    generalBackupRestore: "Sichern & Wiederherstellen",
    generalAccessManagement: "Rechteverwaltung",
    generalUserAndRoles: "Benutzerrechte",
    generalComingSoon: "Demnächst verfügbar",
    generalPaymentMethods: "Bezahlmethoden",
    linkTrackerHeader: 'Neuen Tracker für {{company}} starten',
    linkTrackerProduct: 'Wähle einen Produkt aus',
    linkTrackerTracker: 'Wähle einen gültigen Tracker aus',
    linkTrackerStatus: 'Wähle ein initialen Status aus',
    openingTimeItemOn: 'Am',
    trackerName: 'Tracker Name',
    stepLabelLinktTrackerFirst: 'Tracker Typ + Tracker Name',
    stepLabelLinktTrackerSecond: 'Zusätzliche Informationen',
    openingTimeItemSelectDay: 'Wähle einen Tag',
    openingTimeItemFrom: 'Von',
    openingTimeItemTo: 'Bis',
    projectTableTitle: "Projektübersicht",
    projectTableCustomer: 'Kunde',
    projectTableOrderNr: 'Bestell-Nr. (Kunde)',
    projectTableOfferNr: 'Angebot-Nr. (yasc)',
    projectTableProjectName: 'Projektname',
    projectTableTeam: 'Mitarbeiter',
    projectTableStatus: 'Projektstatus',
    projectTableNextBill: 'Nächste Rechnungstellung',
    projectTableBillFull: 'Rechnungssumme insgesamt',
    projectTableBillPart: 'Teil Betrag',
    projectTableBillDue: 'Fällig am',
    projectTableComments: 'Bemerkung',
    projectTable: 'Fertigstellungsgrad',
    projectTableTask: 'Task',
    projectTableToDo: 'Nächstes TODO',
    projectTableNoBill: 'Keine Abrechnung gefunden',
    projectTabletNoToDo: 'Keine Tickets gefunden',
    projectTableAddRole: 'Rolle',
    projectTableAddInvoiceType: 'Abrechnungs typ',
    projectTableVolume: 'Projektvolumen',
    projectTableInvoiceCnt: 'Anzahl der Abrechnungen',
    projectTablePartialAmount: 'Teil Betrag',
    projectTableDueDate: 'Fälligkeitsdatum',
    projectTableInvoice: 'Abrechnungen',
    projectTableTooSmallDate: 'Das Gewählte Datum ist kleiner als das des letzten bezahlten eintrag und konnte nicht gesetzt werden',
    projectTableCustomerNr: 'Kunden Nr',
    projectTableRemainingAmount: 'Offener Betrag',
    projectAddNewProject: 'Neues Projekt anlegen',
    projectBillsTitle: 'Rechnungsdetails',
    projectBillsHelpTextPre: "In diesem Bereich können Sie Rechnungen für das ausgewählte Projekt verwalten und ausstellen.",
    projectBillsHelpTextAfter: "Rechnungen können bearbeitet werden, bis die Rechnung versendet wurde. Änderungen sind dann nur noch über eine Revision möglich.",
    projectSlideOutTeamHeader: 'Team Details',
    projectTabGeneralTitle: "Projektdetails",
    projectTabGeneralName: "Details",
    projectTabTeamTitle: "Projektteam",
    projectTabTeamName: "Team",
    projectTabTodoTitle: "Projektaufgaben",
    projectTabTodoName: "Todos",
    projectTabTaskTitle: "Projekttasks",
    projectTabTaskName: "Tasks",
    projectTabInvoicesTitle: "Rechnungen",
    projectTabInvoicesName: "Rechnungen",
    projectCreatedInvoices: "Erzeugte Rechnungen",
    StartDate:'Start Datum',
    EndDate:'End Datum',
    StartTime:'Start Zeit',
    EndTime:'End Zeit',
    inRange:'Überlappt mit anderem Eintrag',
    endBefore:'Ende Liegt Vor dem Start',
    descriptionOrTask:'Wähle eine Aufgabe oder füge eine beschreibung hinzu',
    appointmentColor:'Termin Farbe',
    timeManagerImportExcel:'Excel importieren',
    statusHeaderCurrent: 'Status des Unternehmens',
    statusHeaderNoTrackerFound: 'Keine Tracker gefunden',
    toDoNoGroupsFound: 'Keine ToDo Gruppen gefunden',
    toDoCreateNewGroup: 'Neue Gruppe Erstellen',
    toDoNoTodosFoundInGroup: 'Keine ToDos in der Gruppe gefunden',
    toDoAddNew: 'Neues Todo anlegen',
    noTrackerFound: 'Keine Tracker gefunden',
    tracker: 'Tracker',
    noTrackers: 'Keine Tracker vorhanden. ',
    convertToTask: 'in Task umwandeln',
    noContractsFound: 'Keine Verträge gefunden',
    navInventory: 'Inventar',
    navGlobalVariables: "Variables",
    navResources: "Ressourcen",
    navDiagnosticLogs: "Server Logs",
    navButtonHumanResources: "Ressourcenplanung",
    navButtonProjectBudgets: "Projekt Budgets",
    navButtonTimeManagement: "Zeit Manager",
    navButtonApproveOffDay: "Urlab Bestätigen",
    navCp: "Kundenportal",
    navCrm: "CRM",
    navFibu: "Buchhaltung",
    navFin: "Finanzen",
    navButtonDashboard: 'Home',
    navButtonTracker: 'Nachverfolgung',
    navButtonDiagram: 'Diagramme',
    navButtonWorkflow: 'Workflow',
    navButtonToDo: 'Aufgaben',
    navButtonProject: 'Projekte',
    navButtonCompany: 'Firmen',
    navButtonContacts: 'Kontakte',
    navFibUnpostedVouchers: 'Ungebuchte Belege',
    navFibTransactions: 'Transaktionen',
    navFibBatchBooking: 'Stapelbuchung',
    navFibUnbookedVouchers: "Ungebuchte Beläge",
    navFibBankAccounts: 'Bankverbindungen',
    navFibJournal: 'Journal',
    navGlobalPermissions: "Globale Berechtigungen",
    generalPermissions: "Berechtigungen",
    generalPermission: "Berechtigung",
    permissionActionBase: "Gruppe",
    permissionActionName: "Aktion",
    navUsers: "Benutzerliste",
    navGlobalRoles: "Globale Rollen",
    navFibRecurring: 'Wiederkehrend',
    navFibTemplates: 'Import Templates',
    navFibBankSettings: "Banken",
    navFibAccountPlan: "Kontenplan",
    navFibRecurringTitle: 'Wiederkehrende Buchungen',
    navFibExport: 'Export',
    navFibAccountCreate: "Konto erstellen",
    navEmailClients: "Email-Clients",
    finTransactions: "Bank-Transaktionen",
    finBank: "Bank",
    finCashBox: "Kasse",
    finSelectBankAccount: "Bitte wählen Sie das zugehörige Bankkonto",
    none: 'Keine Abrechnung',
    evenDistro: 'Gleichmäßige aufteilung',
    custom: 'Selbsterstellt',
    asTheyCome: 'Ad Hoc',
    fibuForms: "Aktive WebForms",
    fibuBookingDate: 'Buchungsdatum',
    fibuBookingPrefix: 'Kürzel',
    fibuBookingNumber: 'Buchungsnummer',
    fibuBookingText: 'Buchungstext',
    fibuBookingTotal: 'Betrag',
    fibuBookingTotalBrutto: 'Brutto Betrag',
    fibuBookingTotalNetto: 'Nettopreis',
    fibuBookingAmountType: 'Betrag Typ',
    fibuBookingCredit: 'Soll',
    fibuAddCredit: 'Splittung Soll',
    fibuAddDebit: 'Splittung Haben',
    fibuBookingDebit: 'Haben',
    fibuBookingAccount: 'Buchungskonto',
    fibuBookingAccountAddPattern: "Fügen Sie ein Regulären Ausdruck hinzu, um die automatisierte Zuordnung von Rechnungsnummern zu verbessern",
    fibuBookingVatAccount: 'Steuerkonto',
    fibuBookItems: 'Buchen',
    fibuBookItemsDialog: 'Wollen Sie alle Einträge in das Journal buchen?',
    fibuBookItemsNum: 'Wollen Sie wirklich {{amount}} Einträge in das Journal buchen?',
    fibuBookItemsSingle: 'Wollen Sie wirklich einen Eintrag in das Journal buchen?',
    fibuBookItemsDialogSingle: 'Wirklich in Journal buchen?',
    fibuOnlyNewBookings: "Nur neue Belege",
    fibuDatevDistributionChannels: "Vertriebswege",
    fibuVoucherType: "Belegeart",
    fibuAddVouchers: "Belege hinzufügen",
    fibuBookingType: "Buchungsart",
    fibuExportOptions: "Export",
    fibuImportDialogMappingTitle: "Zuordnung Importdaten",
    fibuImportDialogMappingSubText: "Bitte geben Sie Auskunft über die Zuordnung ihrer Quelldaten. Dieser Dialog importiert Umsatzdaten aus den verschiedensten Systemen, mit Hilfe von bereits angelegten Schemata. Mit diesen werden die in der Datei vorhandenen Daten in das Zielsystem übertragen. Ein schema können Sie jederzeit unter Buchhaltung / Tempaltes definierten oder ändern.",
    fibuTemplateName: "Name des Templates",
    fibuBookingImportTemplates: "Import Vorlagen (Templates)",
    fibuSelectedUploadTemplate: "Ausgewähltes Upload-Template",
    fibuBookedBy: "Gebucht von",
    fibuAmount: "Betrag",
    fibuAccountNumber: "Nr",
    fibuAccountName: "Account Name",
    fibuAccountType: "Account Typ",
    fibuAccountCategory: "Account Kategorie",
    fibuAccountTaxAccount: "Standard Steuersatz",
    fibuCredit: "Kreditor",
    fibuDebit: "Debitor",
    fibuGlAccount: "Sachkonto",
    fibuCreateImportTemplateTitle: "Import Vorlage erstellen",
    fibuImportTemplateHelpTextPre: "Laden Sie eine CSV-Datei hoch, aus der Sie ein Template erstellen möchten",
    fibuImportTemplateHelpTextAfter: "Anschließend können Sie die Quellspalten für die benötigten Buchungsinformationen auswählen",
    fibuCreateAccountPlan: "Erstellen Sie einen Kontotyp für Ihre Buchhaltung. Der Kontotyp Debitor/Kreditor oder Sachkonto ist entscheidend für die Kalkulation und die steuerlich korrekte Zuordnung von Buchungen",
    fibuCreateBooking: "Stapelbuchung erstellen",
    fibuCreateBookingHelpTextPre: "Erstellen Sie hier eine neue Buchung für den Buchungsstapel. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich auch gleich Ihre Belege an.",
    fibuCreateBookingHelpTextAfter: "Nach dem Speichern ist die Buchung sofort im Stapel verfügbar.",
    fibuCreateTxAlias: "Gläubiger Alias erstellen",
    fibuCreateTxAliasHelpTextPre: "Erstellen Sie hier einen neuen Alias für einen Gläubiger. Dieser wird unteranderem für die automatische Transaktionszuordnung verwendet werden. Oft hat ein Gläubiger wie z.B.'Amazon' mehrere Identitäten wenn es um Banktransaktionen geht. Beispielsweise werden im Bankverkehr Namen wie 'AMAZON EU S.A R.L.' oder 'AMAZON PAYMENTS EUROPE S.C.A.' benutzt",
    fibuCreateTxAliasTextAfter: "Bestimmen Sie im folgenden ein oder mehrere Aliase für Ihren Gläubiger um die automatische Zuordnung zu verbessern.",
    fibuCurrentAliasNames: "Aktuelle Aliasse",
    fibuNoAliasNamesPresent: "Kein Aliasse vorhanden",
    fibuFinancialYear: "Geschäftsjahr",
    fibuFinancialMonth: "Buchungsmonat",
    fibuBalanceSheet: "Bilanz",
    fibuIncomeSurplusCalculation: "EÜR",
    fibuGeneralAccountType: "Kontotyp",
    fibuHasSplits: "Splitbuchung",
    fibuBookingMaskDefault: "Standart Buchungsmaske",
    fibuBookingMaskAccount: "Buchungsmaske über Bankkonto",
    fibuBookingError: "Hinweise",
    fibuConCreate: "Bankverbindung herstellen",
    fibuConMakeConnection: "Verbindung herstellen",
    fibuConRemoveConnection: "Verbindung trennen",
    fibuConForwardFinapi: "Weiter zur Anmeldung",
    finApiBankId: "FinApi BankId",
    fibuConCreateHelpText: "Geben Sie Ihre Zugangsdaten für Ihre ausgewählte Verbindung ein. Ihre Eingaben werden verschlüsselt an die Bank übermittelt.",
    fibuConCreateHelpText2: "Die Verbindungsdaten werden ausschließlich dafür verwendet Umsätze anzuzeigen und Buchungen zuzuordnen.",
    fibuTransactionsBooked: "Gebucht",
    fibuTransactionsAccountNumber: "Account Nummer",
    fibuTransactionsBankBookingDate: "Buchungstag",
    fibuTransactionsCounterpart: "Gläubiger",
    fibuTransactionsPurpose: "Verwendungszweck",
    fibuTransactionsTotal: "Betrag",
    fibuFinApiStatusPENDING: "Erstellt",
    fibuFinApiStatusINPROGRESS: "In Verarbeitung",
    fibuFinApiStatusREADY: "Verbunden",
    fibuLocalBookingAccount: "Lokales Buchungskonto",
    fibuExportLexwareXml: "Lexware XML Export",
    fibuExportLexwareCsv: "Lexware CSV Export",
    fibuExportTotal: "Buchungen insgesamt",
    fibuExportNewBookings: "Neue Buchungen",
    fibuExportSelected: "Buchungen betroffen",
    fibuExportNotSelected: "Buchungen nicht betroffen",
    fibuRecurrence: "Tag der Ausführung",
    fibuBookedRecurring: "{{booking}} wurde erfolgreich in den Stapel übertragen",
    fibuSplitCredit: "Soll",
    fibuSplitDebit: "Haben",
    fibuBookingSource: "Quelle",
    fibuImportReceipts: "Belege importieren",
    bookingSourceManual: "Manuell",
    bookingSourceRecurring: "Buchungsvorlage",
    bookingSourceFinApi: "FinApi",
    bookingSourceEmail: "Email",
    bookingSourceLexware: "Lexware",
    bookingSourceOcrImport: "OcrImport",
    finApiCreated: "Erstellt",
    finApiPending: "Wartend",
    finApiConnected: "Verbunden",
    finApiFailure: "Fehler",
    finApiPaused: "Pausiert",
    generalExecutionDay: "Ausführungstag",
    generalInterval: "Interval",
    generalFormat: "Format",
    generalDateFrom: "Datum von",
    generalDateUntil: "Datum bis",
    generalCreatedBy: "Erstellt von",
    generalStatus: "Status",
    generalVouchers: "Belege",
    generalRegexExpressions: "Reguläre Ausdrücke",
    daily: "Täglich",
    weekly: "Wöchentlich",
    monthly: "Monatlich",
    semiAnnual: "Halbjährlich",
    annual: "Jährlich",
    datevFormatJournalBased: "DATEV Journal basiert",
    datevBookingBased: "DATEV Buchungs basiert",
    datevStammdaten: "DATEV Stammdaten basiert",
    standardNetto: "Netto",
    standardBrutto: "Brutto",
    verkaufsrechnung: "Verkaufsrechnung",
    einkaufsrechnung: "Einkaufsrechnung",
    verkaufsGutschrift: "VerkaufsGutschrift",
    einkaufsGutschrift: "EinkaufsGutschrift",
    verkaufsSchlussrechnung: "VerkaufsSchlussrechnung",
    einkaufsSchlussrechnung: "EinkaufsSchlussrechnung",
    gutschriftsanzeige: "Gutschriftsanzeige",
    ausgangsrechnung: "Ausgangsrechnung",
    ausgehendeGutschrift: "AusgehendeGutschrift",
    gutschriftanzeige: "Gutschriftanzeige",
    eingangsrechnung: "Eingangsrechnung",
    eingehendeGutschrift: "Eingehende Gutschrift",
    eingehendeZahlung: "Eingehende Zahlung",
    ausgehendeZahlung: "Ausgehende Zahlung",
    sachbuchung: "Sachbuchung",
    vortragsbuchung: "Vortragsbuchung",
    eingehendeManuelleErfassung: "Eingehende manuelle Erfassung",
    ausgehendeManuelleErfassung: "Ausgehende manuelle Erfassung",
    skr03: "Skr-03",
    skr04: "Skr-04",

    emailIntegrationFormularCreate: "Email-Client erstellen",
    emailIntegrationFormularUpdate: "Email-Client aktualisieren",
    emailIntegrationFormularHelpTextPre: "Erstellen Sie hier einen neuen globalen Email-Client. Füllen Sie mindestens alle Pflichtfelder aus.",
    emailIntegrationFormularHelpTextAfter: "Dieser kann für zahlreiche Features innerhalb der applikation verwendet werden.",
    emailIntegrationClientType: "Client Typ",
    emailIntegrationEmail: "Email",
    emailIntegrationHost: "Host",
    emailIntegrationPort: "Port",
    emailIntegrationUserName: "Username",
    emailIntegrationPassword: "Passwort",
    emailIntegrationUseSsl: "Ssl verwenden",
    emailIntegrationDescription: "Beschreibung",
    emailIntegrationLastUsed: "Zuletzt verwendet",
    emailConnectionStatus: "Verbindungsstatus",
    emailIntegrationTestReceiver: "Empfänger Test Email",
    emailTestConnection: "Verbindung Testen",
    connectionSuccessText: "Verbindung hergestellt",
    connectionFailedText: "Verbindung fehlgeschlagen",

    ///CRM WORKFLOW
    workflowUsedIn: 'Genutzt in {{count}} {{type}}',
    workflowNotUsed: 'keinem',
    workflowAdd: 'Workflow hinzufügen',
    workflowUpdate: 'Änderung übernehmen',
    workflowDiscard: 'Änderungen verwerfen',
    workflowAddStatus: 'Status hinzufügen',
    workflowAddTransition: 'Link hinzufügen',
    statusAdvanceTo: 'Aktuellen Projekt status auf {{status}} setzen',
    currentStatus: 'Aktueller Status',
    nextPossibleStatus: 'Nächsten Mögliche Status',
    toDo: 'To-Do',
    toDoPlu: 'To-Do´s',
    product: 'Produkt',
    productPlu: 'Produkten',
    project: 'Projekt',
    projectPlu: 'Projekten',
    noProject: 'Es liegen keine Projekte vor',
    recruitment: 'Rekrutierung',
    name: 'Name',
    color: 'Farbe',
    description: 'Beschreibung',
    label: 'Link Label',
    from: 'Von',
    to: 'Nach',
    save: 'Speichern',
    cancel: 'Abbrechen',
    workflowLinksToStates: 'Verbindungen zu anderen Status',
    fromStatus: 'von Status',
    toStatus: 'zu Status',
    transition: 'Übergang',
    statusFilterNone: 'Kein Status Ausgewählt',
    statusFilterAll: 'Alle Status ausgewählt',

    Daily: 'Tagesansicht',
    Weekly: 'Wochenansicht',
    Monthly: 'Monatsansicht',
    Yearly: 'Jährlich',
    recExpandAll: 'Alle ausklappen',
    recCollapseAll: 'Alle einklappen',
    recDateRangeSetting: 'Von - Bis Einstellung',

    plannedHour: 'Verplante Stunden',
    estimatedHour: 'Erwartete Stunden',
    usedTime: 'Genutzte Zeit',
    user: 'Nutzer',

    addInvoice: 'Rechnung hinzufügen',
    sendInvoice: 'Rechnung senden',
    paymentTarget: 'Rechnungsziel',
    paidOn: 'Bezahlt am',
    paid: 'Bezahlt',
    date: 'Datum',
    amount: 'Anzahl',
    price: 'Kosten',
    unit: 'Einheit',
    add: 'Hinzufügen',
    remaining: 'noch zu Zahlen',

    recDateOffset: '',

    recOpenDialog: 'Wiederkehrend',
    directiveStart: '',
    task: 'Aufgabe',
    recStart: 'Start',
    recDuration: 'Dauer',
    recFrequency: 'Frequence',
    recInterval: 'Interval',
    recEnd: 'Ende',
    recEndOption: 'End Option',
    recCount: 'Anzahl',
    recProjectView: 'Projektansicht',
    recUserView: 'Mitarbeiteransicht',
    addNewProject: 'Neues Projekt hinzufügen',
    addWorkflow: 'Workflow hinzufügen',
    workflowEditorShowEdgeLabel: 'Kanten Label anzeigen',
    workflowEditorStatusSettings: 'Status Einstellung',
    workflowEditorEdgeSettings: 'Link Einstellung',
    center: 'Ansicht zentrieren',
    humanResourcesInvalidTimeInput: 'Nicht zugelassener Wert',

    timeManagerHalfDay: 'Halben Tag',
    timeManagerFullDay: 'Ganzen Tag',
    timeManagerSubmit: 'Urlaub einreichen',
    timeManagerVacation: 'Urlaub Buchen',
    timeManagerBookedVacation: 'Gebuchter Urlaub',
    timeManagerApproved: 'Genemigt',
    timeManagerApprovalPending: 'Genemigung Austehend',
    Vacation: 'Urlaub',
    SickDay: 'Krank',
    Holiday: 'Feiertag',
    TimeCompensation: 'Zeitausgleich',

    timeManagerUsedHoursForYear: 'Gebuchte stunden für das jahr {{year}}',
    timeManagerOverTimeTargetHours: 'Soll Stunden',
    timeManagerCalendarWeek: 'KW',
    timeManagerOverTimeActualHours: 'Ist Stunden',
    timeManagerMonthBreakdown: 'Monats Ansicht',
    timeManagerOverTime: 'Überstunden',

    calendar_noEntries: "Keine Einträge für diesen Tag",
    calendar_event_type: "Eventtyp",
    calendarTypeWorkTime: "Arbeitszeit",
    calendarTypeVacation: "Urlaub",
    calendarTypeTimeOff: "Stundenausgleich",
    calendarTypeSick: "Krank",
    calendarTypeAppointment: "Termin",
    calendarTypeUnknown: "Eintrag",

    calendar_allDay: "Ganztägig",
    yearCalendar_month_missingEntry_tooltip: 'Zeiterfassung fehlt. Klicken öffnet den betreffenden Tag.',
    calendar_dayPart: "Tagesabschnitt",
    calendar_carryOver: "Übertrag",

    calendar_dayPartNone: "Kein Teil",
    calendar_dayPartMorning: "Vormittag",
    calendar_dayPartAfternoon: "Nachmittag",
    calendar_dayPartFullDay: "Ganzer Tag",

    calendar_halfDay_disabled_tooltip: "Halbtägige Einträge sind nur bei einem einzigen Tag möglich.",

    calendar_action_edit: "Bearbeiten",
    calendar_action_edit_tooltip: "Diesen Eintrag bearbeiten",
    calendar_action_withdraw: "Zurückziehen",
    calendar_action_withdraw_tooltip: "Diesen ausstehenden Antrag zurückziehen",
    calendar_action_cancel: "Stornieren",
    calendar_action_cancel_tooltip: "Diesen genehmigten Eintrag stornieren (mit Historie)",
    calendar_action_delete: "Löschen",
    calendar_action_delete_tooltip: "Diesen Eintrag endgültig entfernen",
    calendar_action_approve: "Genehmigen",
    calendar_action_approve_tooltip: "Diesen Antrag genehmigen",
    calendar_action_reject: "Ablehnen",
    calendar_action_reject_tooltip: "Diesen Antrag ablehnen",
    calendar_action_showHistory: "Verlauf anzeigen",
    calendar_action_showHistory_tooltip: "Entscheidungs- und Änderungsverlauf anzeigen",
    calendar_action_acceptInvitation: "Einladung annehmen",
    calendar_action_acceptInvitation_tooltip: "Diese Einladung annehmen",
    calendar_action_declineInvitation: "Einladung ablehnen",
    calendar_action_declineInvitation_tooltip: "Diese Einladung ablehnen",

    calendar_recurrence: "Wiederholung",
    calendar_recurrencePreset: "Wiederholungs Vorlage",

    calendar_recurrenceNone: "Keine Wiederholung",
    calendar_recurrenceDaily: "Täglich",
    calendar_recurrenceWeekly: "Wöchentlich",
    calendar_recurrenceWeekdays: "Wochentage Mo bis Fr",
    calendar_recurrenceMonthly: "Monatlich",

    calendar_recurrenceHintExample: "Beispiel FREQ=WEEKLY;BYDAY=MO,WE,FR",
    calendar_currentWeek: "Kalenderwoche",

    calendar_help_allDay: "Setzt Uhrzeit automatisch auf den ganzen Tag. Die Auswertung behandelt den Eintrag als Tagesereignis.",
    calendar_help_dayPart: "Legt fest, ob der Eintrag als halber oder ganzer Tag gewertet wird. Wird vor allem bei Abwesenheiten genutzt.",
    calendar_help_carryOver: "Markierung für Auswertung und Kontingente. Wird nur bei Urlaub und Stundenausgleich verwendet.",
    calendar_help_recurrence: "Erzeugt wiederkehrende Einträge. Für Arbeitszeit und Termine verfügbar.",

    calendar_summary_title: "Zusammenfassung",
    calendar_summary_range: "Zeitraum",
    calendar_summary_duration: "Zeitspanne",
    calendar_summary_counting: "Wertung",
    calendar_summary_recurrence: "Wiederholung",
    calendar_summary_carryOverFlag: "Übertrag aktiv",

    calendar_summary_counting_timeSpan: "Wird anhand der Zeitspanne ausgewertet.",
    calendar_summary_counting_allDay: "Wird als ganztägig ausgewertet.",
    calendar_summary_counting_dayPart: "Wird über den Tagesabschnitt ausgewertet.",

    calendar_section_required: "Pflichtangaben",
    calendar_section_optional: "Optionale Angaben",
    calendar_section_advanced: "Erweitert",
    calendarEntryLabelShort_workTime: "AZ",
    calendarEntryLabelShort_vacation: "U",
    calendarEntryLabelShort_timeOff: "ZA",
    calendarEntryLabelShort_publicHoliday: "FT",
    calendarEntryLabelShort_sick: "K",
    calendarEntryLabelShort_appointment: "T",
    calendarEntryLabelShort_unknown: "E",
    calendarEntryLabel_workTime: "Arbeitszeit",
    calendarEntryLabel_vacation: "Urlaub",
    calendarEntryLabel_timeOff: "Zeitausgleich",
    calendarEntryLabel_sick: "Krank",
    calendarEntryLabel_appointment: "Termin",
    calendarEntryLabel_unknown: "Eintrag",

    validation_requiredTitle: "Titel ist erforderlich",
    validation_requiredProject: "Projekt ist erforderlich",
    validation_requiredDescription: "Beschreibung ist erforderlich",

    validation_rRuleMissing: "RRULE fehlt",
    validation_invalidRRule: "Ungültige Wiederholungsregel",
    validation_invalidTimeZoneId: "Ungültige Zeitzone",

    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag',

    // Contracting - general
    navContracting: 'Verträge und Lizenzen',
    navContractAssignment: 'Vertragsübersicht',

    // Contracting - LicenseAssignment - general
    navLicenseAssignment: 'Lizenzübersicht',
    tableLicenseAssignment: 'Tabelle Lizenzübersicht',
    emptyPageTextLicenseAssignment: 'Es sind noch keine Einträge für Lizenzen erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Contracting - LicenseAssignment - attributes
    contractingLicenseAssignmentGuid: "Guid",
    contractingLicenseAssignmentCreatedAt: "Erstellungsdatum",
    contractingLicenseAssignmentCreatedBy: "Erstellt durch",
    contractingLicenseAssignmentUpdatedAt: "Aktualisierungsdatum",
    contractingLicenseAssignmentUpdatedBy: "Aktualisiert durch",
    contractingLicenseAssignmentDeviceCount: "Anzahl Endgeräte",
    contractingLicenseAssignmentName: "Lizenzname",
    contractingLicenseAssignmentTitle: "Lizenztitel",
    contractingLicenseAssignmentDescription: "Beschreibung der Lizenz",

    // Contracting - LicenseAssignment - attributes tooltips
    contractingLicenseAssignmentGuidTooltip: "TODO Tooltip Guid",
    contractingLicenseAssignmentCreatedAtTooltip: "TODO Tooltip Erstellungsdatum",
    contractingLicenseAssignmentCreatedByTooltip: "TODO Tooltip Erstellt durch",
    contractingLicenseAssignmentUpdatedAtTooltip: "TODO Tooltip Aktualisierungsdatum",
    contractingLicenseAssignmentUpdatedByTooltip: "TODO Tooltip Aktualisiert durch",
    contractingLicenseAssignmentDeviceCountTooltip: "TODO Tooltip Anzahl Endgeräte",
    contractingLicenseAssignmentNameTooltip: "TODO Tooltip Lizenzname",
    contractingLicenseAssignmentTitleTooltip: "TODO Tooltip Lizenztitel",
    contractingLicenseAssignmentDescriptionTooltip: "TODO Tooltip Beschreibung der Lizenz",

    contractingCreateLicenseAssignment: "Neuen Eintrag einer Lizenz erstellen",
    contractingCreateLicenseAssignmentHelpTextPre: "Erstellen Sie hier einen neuen Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingCreateLicenseAssignmentHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht verfügbar.",

    contractingUpdateLicenseAssignment: "Bestehenden Eintrag einer Lizenz aktualisieren",
    contractingUpdateLicenseAssignmentHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingUpdateLicenseAssignmentHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht aktualisiert.",

    // Contracting - LicenseAssignment - ConfirmationDialogComponent
    contractingUpdateLicenseAssignmentCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen einer neuen Lizenz abbrechen wollen?",
    contractingUpdateLicenseAssignmentUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren einer bestehenden Lizenz ({{guid}}) abbrechen wollen?",
    contractingUpdateLicenseAssignmentDeleteConfirmation: "Sind Sie sicher, daß Sie die bestehende Lizenz ({{guid}}) löschen wollen?",

    // Contracting - LicenseAssignment - notifications
    contractingUpdateLicenseAssignmentNotificationCreateCancel: "Das Erstellen einer neuen Lizenz wurde abgebrochen.",
    contractingUpdateLicenseAssignmentNotificationCreateSuccess: "Die neue Lizenz wurde erfolgreich erstellt.",

    contractingUpdateLicenseAssignmentNotificationUpdateCancel: "Das Aktualisieren einer bestehenden Lizenz ({{guid}}) wurde abgebrochen.",
    contractingUpdateLicenseAssignmentNotificationUpdateSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich aktualisiert.",

    contractingUpdateLicenseAssignmentNotificationDeleteSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich gelöscht.",


    // update starts here
    // Contracting - general
    // navContracting: 'Contracting',

    // Contracting - DeviceData - general
    navDeviceData: 'Geräteübersicht',
    tableDeviceData: 'Tabelle Geräteübersicht',
    emptyPageTextDeviceData: 'Es sind noch keine Einträge für Geräte erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Contracting - DeviceData - attributes label
    contractingDeviceDataGuidLabel: "Guid",
    contractingDeviceDataCreatedAtLabel: "CreatedAt",
    contractingDeviceDataUpdatedAtLabel: "UpdatedAt",
    contractingDeviceDataCreatedByLabel: "CreatedBy",
    contractingDeviceDataUpdatedByLabel: "UpdatedBy",
    contractingDeviceDataMachineUniqueIdLabel: "MachineUniqueId",
    contractingDeviceDataMachineHostNameLabel: "MachineHostName",
    contractingDeviceDataCpuArchitectureLabel: "CpuArchitecture",
    contractingDeviceDataKernelTypeLabel: "KernelType",
    contractingDeviceDataKernelVersionLabel: "KernelVersion",
    contractingDeviceDataPrettyProductNameLabel: "PrettyProductName",
    contractingDeviceDataProductTypeLabel: "ProductType",
    contractingDeviceDataProductVersionLabel: "ProductVersion",
    contractingDeviceDataInstallationDateLabel: "InstallationDate",
    contractingDeviceDataActiveLabel: "Active",
    contractingDeviceDataMachineUserLabel: "MachineUser",
    contractingDeviceDataIpV6Label: "IpV6",
    contractingDeviceDataIpV4Label: "IpV4",
    contractingDeviceDataNoteLabel: "Note",

    // Contracting - DeviceData - attributes tooltips
    contractingDeviceDataGuidToolTip: "Guid",
    contractingDeviceDataCreatedAtToolTip: "Created At",
    contractingDeviceDataUpdatedAtToolTip: "Updated At",
    contractingDeviceDataCreatedByToolTip: "Created By",
    contractingDeviceDataUpdatedByToolTip: "Updated By",
    contractingDeviceDataMachineUniqueIdToolTip: "Machine Unique Id",
    contractingDeviceDataMachineHostNameToolTip: "Machine Host Name",
    contractingDeviceDataCpuArchitectureToolTip: "Cpu Architecture",
    contractingDeviceDataKernelTypeToolTip: "Kernel Type",
    contractingDeviceDataKernelVersionToolTip: "Kernel Version",
    contractingDeviceDataPrettyProductNameToolTip: "Pretty Product Name",
    contractingDeviceDataProductTypeToolTip: "Product Type",
    contractingDeviceDataProductVersionToolTip: "Product Version",
    contractingDeviceDataInstallationDateToolTip: "Installation Date",
    contractingDeviceDataActiveToolTip: "Active",
    contractingDeviceDataMachineUserToolTip: "Machine User",
    contractingDeviceDataIpV6ToolTip: "Ip V6",
    contractingDeviceDataIpV4ToolTip: "Ip V4",
    contractingDeviceDataNoteToolTip: "Note",

    // Contracting - DeviceData - attributes placeholder
    contractingDeviceDataGuidPlaceholder: "Guid",
    contractingDeviceDataCreatedAtPlaceholder: "Created At",
    contractingDeviceDataUpdatedAtPlaceholder: "Updated At",
    contractingDeviceDataCreatedByPlaceholder: "Created By",
    contractingDeviceDataUpdatedByPlaceholder: "Updated By",
    contractingDeviceDataMachineUniqueIdPlaceholder: "Machine Unique Id",
    contractingDeviceDataMachineHostNamePlaceholder: "Machine Host Name",
    contractingDeviceDataCpuArchitecturePlaceholder: "Cpu Architecture",
    contractingDeviceDataKernelTypePlaceholder: "Kernel Type",
    contractingDeviceDataKernelVersionPlaceholder: "Kernel Version",
    contractingDeviceDataPrettyProductNamePlaceholder: "Pretty Product Name",
    contractingDeviceDataProductTypePlaceholder: "Product Type",
    contractingDeviceDataProductVersionPlaceholder: "Product Version",
    contractingDeviceDataInstallationDatePlaceholder: "Installation Date",
    contractingDeviceDataActivePlaceholder: "Active",
    contractingDeviceDataMachineUserPlaceholder: "Machine User",
    contractingDeviceDataIpV6Placeholder: "Ip V6",
    contractingDeviceDataIpV4Placeholder: "Ip V4",
    contractingDeviceDataNotePlaceholder: "Note",

    contractingCreateDeviceData: "Neuen Eintrag eines Geräts erstellen",
    contractingCreateDeviceDataHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Geräts für die Geräteübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Gerät an.",
    contractingCreateDeviceDataHelpTextAfter: "Nach dem Speichern ist das erstellte Gerät sofort in der Geräteübersicht verfügbar.",

    contractingUpdateDeviceData: "Bestehenden Eintrag einer DeviceData aktualisieren",
    contractingUpdateDeviceDataHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Geräts für die Geräteübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Gerät an.",
    contractingUpdateDeviceDataHelpTextAfter: "Nach dem Speichern ist das erstellte Gerät sofort in der Geräteübersicht aktualisiert.",

    // Contracting - DeviceData - ConfirmationDialogComponent
    contractingUpdateDeviceDataCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Geräts abbrechen wollen?",
    contractingUpdateDeviceDataUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Geräts ({{guid}}) abbrechen wollen?",
    contractingUpdateDeviceDataDeleteConfirmation: "Sind Sie sicher, daß Sie das bestehende Gerät ({{guid}}) löschen wollen?",

    // Contracting - DeviceData - notifications
    contractingUpdateDeviceDataNotificationCreateCancel: "Das Erstellen eines neuen Geräts wurde abgebrochen.",
    contractingUpdateDeviceDataNotificationCreateSuccess: "Das neue Gerät wurde erfolgreich erstellt.",

    contractingUpdateDeviceDataNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Geräts ({{guid}}) wurde abgebrochen.",
    contractingUpdateDeviceDataNotificationUpdateSuccess: "Das bestehende Gerät ({{guid}}) wurde erfolgreich aktualisiert.",

    contractingUpdateDeviceDataNotificationDeleteSuccess: "Das bestehende Gerät ({{guid}}) wurde erfolgreich gelöscht.",

    // Contracting - LicenseData - general
    navLicenseData: 'Lizenzübersicht',
    tableLicenseData: 'Tabelle Lizenzübersicht',
    emptyPageTextLicenseData: 'Es sind noch keine Einträge für Lizenzen erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Contracting - LicenseData - attributes label
    contractingLicenseDataGuidLabel: "Guid",
    contractingLicenseDataCreatedAtLabel: "CreatedAt",
    contractingLicenseDataUpdatedAtLabel: "UpdatedAt",
    contractingLicenseDataCreatedByLabel: "CreatedBy",
    contractingLicenseDataUpdatedByLabel: "UpdatedBy",
    contractingLicenseDataLicenseIdLabel: "LicenseId",
    contractingLicenseDataLicenceValidLabel: "LicenceValid",
    contractingLicenseDataLicenseTypeLabel: "LicenseType",
    contractingLicenseDataLicensePeriodLabel: "LicensePeriod",
    contractingLicenseDataProductNameLabel: "ProductName",
    contractingLicenseDataProductVersionLabel: "ProductVersion",
    contractingLicenseDataProductDescriptionLabel: "ProductDescription",
    contractingLicenseDataLicenceStartLabel: "LicenceStart",
    contractingLicenseDataLicenceExpiresLabel: "LicenceExpires",
    contractingLicenseDataAutoRenewEnabledLabel: "AutoRenewEnabled",
    contractingLicenseDataUserAllowedLabel: "UserAllowed",
    contractingLicenseDataUserAssignedLabel: "UserAssigned",
    contractingLicenseDataUserLeftLabel: "UserLeft",
    contractingLicenseDataDevicesAllowedLabel: "DevicesAllowed",
    contractingLicenseDataDevicesAssignedLabel: "DevicesAssigned",
    contractingLicenseDataDevicesLeftLabel: "DevicesLeft",
    contractingLicenseDataLicenseKeyLabel: "LicenseKey",
    contractingLicenseDataFallbackProductVersionLabel: "FallbackProductVersion",
    contractingLicenseDataTerminationPeriodLabel: "TerminationPeriod",
    contractingLicenseDataTerminationDateLabel: "TerminationDate",
    contractingLicenseDataLicenseCostLabel: "LicenseCost",
    contractingLicenseDataLicenseCostPerUserYearLabel: "LicenseCostPerUserYear",
    contractingLicenseDataAttachmentListLabel: "AttachmentList",

    // Contracting - LicenseData - attributes tooltips
    contractingLicenseDataGuidToolTip: "Guid",
    contractingLicenseDataCreatedAtToolTip: "Created At",
    contractingLicenseDataUpdatedAtToolTip: "Updated At",
    contractingLicenseDataCreatedByToolTip: "Created By",
    contractingLicenseDataUpdatedByToolTip: "Updated By",
    contractingLicenseDataLicenseIdToolTip: "License Id",
    contractingLicenseDataLicenceValidToolTip: "Licence Valid",
    contractingLicenseDataLicenseTypeToolTip: "License Type",
    contractingLicenseDataLicensePeriodToolTip: "License Period",
    contractingLicenseDataProductNameToolTip: "Product Name",
    contractingLicenseDataProductVersionToolTip: "Product Version",
    contractingLicenseDataProductDescriptionToolTip: "Product Description",
    contractingLicenseDataLicenceStartToolTip: "Licence Start",
    contractingLicenseDataLicenceExpiresToolTip: "Licence Expires",
    contractingLicenseDataAutoRenewEnabledToolTip: "Auto Renew Enabled",
    contractingLicenseDataUserAllowedToolTip: "User Allowed",
    contractingLicenseDataUserAssignedToolTip: "User Assigned",
    contractingLicenseDataUserLeftToolTip: "User Left",
    contractingLicenseDataDevicesAllowedToolTip: "Devices Allowed",
    contractingLicenseDataDevicesAssignedToolTip: "Devices Assigned",
    contractingLicenseDataDevicesLeftToolTip: "Devices Left",
    contractingLicenseDataLicenseKeyToolTip: "License Key",
    contractingLicenseDataFallbackProductVersionToolTip: "Fallback Product Version",
    contractingLicenseDataTerminationPeriodToolTip: "Termination Period",
    contractingLicenseDataTerminationDateToolTip: "Termination Date",
    contractingLicenseDataLicenseCostToolTip: "License Cost",
    contractingLicenseDataLicenseCostPerUserYearToolTip: "License Cost Per User Year",
    contractingLicenseDataAttachmentListToolTip: "Attachment List",

    // Contracting - LicenseData - attributes placeholder
    contractingLicenseDataGuidPlaceholder: "Guid",
    contractingLicenseDataCreatedAtPlaceholder: "Created At",
    contractingLicenseDataUpdatedAtPlaceholder: "Updated At",
    contractingLicenseDataCreatedByPlaceholder: "Created By",
    contractingLicenseDataUpdatedByPlaceholder: "Updated By",
    contractingLicenseDataLicenseIdPlaceholder: "License Id",
    contractingLicenseDataLicenceValidPlaceholder: "Licence Valid",
    contractingLicenseDataLicenseTypePlaceholder: "License Type",
    contractingLicenseDataLicensePeriodPlaceholder: "License Period",
    contractingLicenseDataProductNamePlaceholder: "Product Name",
    contractingLicenseDataProductVersionPlaceholder: "Product Version",
    contractingLicenseDataProductDescriptionPlaceholder: "Product Description",
    contractingLicenseDataLicenceStartPlaceholder: "Licence Start",
    contractingLicenseDataLicenceExpiresPlaceholder: "Licence Expires",
    contractingLicenseDataAutoRenewEnabledPlaceholder: "Auto Renew Enabled",
    contractingLicenseDataUserAllowedPlaceholder: "User Allowed",
    contractingLicenseDataUserAssignedPlaceholder: "User Assigned",
    contractingLicenseDataUserLeftPlaceholder: "User Left",
    contractingLicenseDataDevicesAllowedPlaceholder: "Devices Allowed",
    contractingLicenseDataDevicesAssignedPlaceholder: "Devices Assigned",
    contractingLicenseDataDevicesLeftPlaceholder: "Devices Left",
    contractingLicenseDataLicenseKeyPlaceholder: "License Key",
    contractingLicenseDataFallbackProductVersionPlaceholder: "Fallback Product Version",
    contractingLicenseDataTerminationPeriodPlaceholder: "Termination Period",
    contractingLicenseDataTerminationDatePlaceholder: "Termination Date",
    contractingLicenseDataLicenseCostPlaceholder: "License Cost",
    contractingLicenseDataLicenseCostPerUserYearPlaceholder: "License Cost Per User Year",
    contractingLicenseDataAttachmentListPlaceholder: "Attachment List",

    contractingCreateLicenseData: "Neuen Eintrag einer Lizenz erstellen",
    contractingCreateLicenseDataHelpTextPre: "Erstellen Sie hier einen neuen Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingCreateLicenseDataHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht verfügbar.",

    contractingUpdateLicenseData: "Bestehenden Eintrag einer Lizenz aktualisieren",
    contractingUpdateLicenseDataHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingUpdateLicenseDataHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht aktualisiert.",

    // Contracting - LicenseData - ConfirmationDialogComponent
    contractingUpdateLicenseDataCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen einer neuen Lizenz abbrechen wollen?",
    contractingUpdateLicenseDataUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren einer bestehenden Lizenz ({{guid}}) abbrechen wollen?",
    contractingUpdateLicenseDataDeleteConfirmation: "Sind Sie sicher, daß Sie die bestehende Lizenz ({{guid}}) löschen wollen?",

    // Contracting - LicenseData - notifications
    contractingUpdateLicenseDataNotificationCreateCancel: "Das Erstellen einer neuen Lizenz wurde abgebrochen.",
    contractingUpdateLicenseDataNotificationCreateSuccess: "Die neue Lizenz wurde erfolgreich erstellt.",

    contractingUpdateLicenseDataNotificationUpdateCancel: "Das Aktualisieren einer bestehenden Lizenz ({{guid}}) wurde abgebrochen.",
    contractingUpdateLicenseDataNotificationUpdateSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich aktualisiert.",

    contractingUpdateLicenseDataNotificationDeleteSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich gelöscht.",

    // Inventory - Article - general
    navArticle: 'Artikelübersicht',
    tableArticle: 'Tabelle Artikelübersicht',
    emptyPageTextArticle: 'Es sind noch keine Einträge für Artikel erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Inventory - Article - attributes label
    inventoryArticleGuidLabel: "Universell eindeutiger Identifikator",
    inventoryArticleCreatedAtLabel: "Erstellungszeitpunkt",
    inventoryArticleUpdatedAtLabel: "Aktualisierungszeitpunkt",
    inventoryArticleCreatedByLabel: "Erstellt von",
    inventoryArticleUpdatedByLabel: "Aktualisiert von",
    inventoryArticleBrandLabel: "Marke",
    inventoryArticleProductImageLabel: "Produktbild",
    inventoryArticleModelLabel: "Modell",
    inventoryArticleModelNumberLabel: "Modellnummer",
    inventoryArticleModelCategoryLabel: "Kategorie",
    inventoryArticleWeightLabel: "Gewicht",
    inventoryArticleDimensionsLabel: "Abmessungen",
    inventoryArticleManufactureDateLabel: "Herstelldatum",
    inventoryArticleModelDescriptionLabel: "Beschreibung",
    inventoryArticleLinkLabel: "Link",
    inventoryArticleWarrantyLabel: "Garantie",

    // Inventory - Article - attributes tooltips
    inventoryArticleGuidToolTip: "Tooltip Universell eindeutiger Identifikator",
    inventoryArticleCreatedAtToolTip: "Tooltip Erstellungszeitpunkt",
    inventoryArticleUpdatedAtToolTip: "Tooltip Aktualisierungszeitpunkt",
    inventoryArticleCreatedByToolTip: "Tooltip Erstellt von",
    inventoryArticleUpdatedByToolTip: "Tooltip Aktualisiert von",
    inventoryArticleBrandToolTip: "Tooltip Marke",
    inventoryArticleProductImageToolTip: "Tooltip Produktbild",
    inventoryArticleModelToolTip: "Tooltip Modell",
    inventoryArticleModelNumberToolTip: "Tooltip Modellnummer",
    inventoryArticleModelCategoryToolTip: "Tooltip Kategorie",
    inventoryArticleWeightToolTip: "Tooltip Gewicht",
    inventoryArticleDimensionsToolTip: "Tooltip Abmessungen",
    inventoryArticleManufactureDateToolTip: "Tooltip Herstelldatum",
    inventoryArticleModelDescriptionToolTip: "Tooltip Beschreibung",
    inventoryArticleLinkToolTip: "Tooltip Link",
    inventoryArticleWarrantyToolTip: "Tooltip Garantie",

    // Inventory - Article - attributes placeholder
    inventoryArticleGuidPlaceholder: "Placeholder Universell eindeutiger Identifikator",
    inventoryArticleCreatedAtPlaceholder: "Placeholder Erstellungszeitpunkt",
    inventoryArticleUpdatedAtPlaceholder: "Placeholder Aktualisierungszeitpunkt",
    inventoryArticleCreatedByPlaceholder: "Placeholder Erstellt von",
    inventoryArticleUpdatedByPlaceholder: "Placeholder Aktualisiert von",
    inventoryArticleBrandPlaceholder: "Placeholder Marke",
    inventoryArticleProductImagePlaceholder: "Placeholder Produktbild",
    inventoryArticleModelPlaceholder: "Placeholder Modell",
    inventoryArticleModelNumberPlaceholder: "Placeholder Modellnummer",
    inventoryArticleModelCategoryPlaceholder: "Placeholder Kategorie",
    inventoryArticleWeightPlaceholder: "Placeholder Gewicht",
    inventoryArticleDimensionsPlaceholder: "Placeholder Abmessungen",
    inventoryArticleManufactureDatePlaceholder: "Placeholder Herstelldatum",
    inventoryArticleModelDescriptionPlaceholder: "Placeholder Beschreibung",
    inventoryArticleLinkPlaceholder: "Placeholder Link",
    inventoryArticleWarrantyPlaceholder: "Placeholder Garantie",

    inventoryCreateArticle: "Neuen Eintrag eines Artikels erstellen",
    inventoryCreateArticleHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Artikels für die Artikelübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem inventory an.",
    inventoryCreateArticleHelpTextAfter: "Nach dem Speichern ist der erstellte Artikel sofort in der Artikelübersicht verfügbar.",

    inventoryUpdateArticle: "Bestehenden Eintrag eines Artikels aktualisieren",
    inventoryUpdateArticleHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Artikels für die Artikelübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Artikel an.",
    inventoryUpdateArticleHelpTextAfter: "Nach dem Speichern ist der erstellte Artikel sofort in der Artikelübersicht aktualisiert.",

    // Inventory - Article - ConfirmationDialogComponent
    inventoryUpdateArticleCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Artikels abbrechen wollen?",
    inventoryUpdateArticleUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Artikel ({{title}} - {{guid}}) abbrechen wollen?",
    inventoryUpdateArticleDeleteConfirmation: "Sind Sie sicher, daß Sie den bestehenden Artikel ({{title}} - {{guid}}) löschen wollen?",

    // Inventory - Article - Import // PMP
    inventoryImportCsvArticleListDialogText: "Import Artikel", // PMP
    inventoryImportCsvArticleListDialogSubText: "Bitte wählen Sie den Dateinamen der CSV-Datei für den Import neuer Artikeln aus.", // PMP

    inventoryImportExcelArticleListDialogText: "Import Artikel", // PMP
    inventoryImportExcelArticleListDialogSubText: "Bitte wählen Sie den Dateinamen der Excel-Datei für den Import neuer Artikeln aus.", // PMP

    // Inventory - Article - notifications - entry
    inventoryUpdateArticleNotificationCreateCancel: "Das Erstellen eines neuen Artikels wurde abgebrochen.",
    inventoryUpdateArticleNotificationCreateSuccess: "Der neue Artikel ({{title}} - {{guid}}) wurde erfolgreich erstellt.",
    inventoryUpdateArticleNotificationCreateError: "Der neue Artikel konnte nicht erstellt werden.", // PMP
    inventoryUpdateArticleNotificationCreateUndefinedError: "Der neue Artikel konnte nicht erstellt werden, da er nicht spezifiziert ist.", // PMP

    inventoryUpdateArticleNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Artikels ({{title}} - {{guid}}) wurde abgebrochen.",
    inventoryUpdateArticleNotificationUpdateSuccess: "Der bestehende Artikel ({{title}} - {{guid}}) wurde erfolgreich aktualisiert.",
    inventoryUpdateArticleNotificationUpdateError: "Der bestehende Artikel ({{title}} - {{guid}}) konnte nicht aktualisiert werden.", // PMP
    inventoryUpdateArticleNotificationUpdateUndefinedError: "Der bestehende Artikel konnte nicht aktualisiert werden, da er nicht spezifiziert ist.", // PMP

    inventoryUpdateArticleNotificationDeleteSuccess: "Der bestehende Artikel ({{title}} - {{guid}}) wurde erfolgreich gelöscht.",
    inventoryUpdateArticleNotificationDeleteError: "Der bestehende Artikel ({{title}} - {{guid}}) konnte nicht gelöscht werden.", // PMP
    inventoryUpdateArticleNotificationDeleteUndefinedError: "Der bestehende Artikel konnte nicht gelöscht werden, da er nicht spezifiziert ist.", // PMP

    // Inventory - Article - notifications - entry list
    inventoryUpdateArticleNotificationCreateListCancel: "Das Erstellen der neuen Artikel wurde abgebrochen.", // PMP
    inventoryUpdateArticleNotificationCreateListSuccess: "Die neuen Artikel wurden erfolgreich erstellt.", // PMP
    inventoryUpdateArticleNotificationCreateListError: "Die neuen Artikel konnten nicht erstellt werden.", // PMP
    inventoryUpdateArticleNotificationCreateListUndefinedError: "Die neuen Artikel konnte nicht erstellt werden, da keine spezifiziert wurden.", // PMP

    inventoryUpdateArticleNotificationUpdateListCancel: "Das Aktualisieren der bestehenden Artikels ({{guidList}}) wurde abgebrochen.", // PMP
    inventoryUpdateArticleNotificationUpdateListSuccess: "Die bestehenden Artikel ({{guidList}}) wurden erfolgreich aktualisiert.", // PMP
    inventoryUpdateArticleNotificationUpdateListError: "Die bestehenden Artikel ({{guidList}}) konnten nicht aktualisiert werden.", // PMP
    inventoryUpdateArticleNotificationUpdateListUndefinedError: "Der bestehende Artikel konnte nicht gelöscht werden, da er nicht definiert ist.", // PMP

    inventoryUpdateArticleNotificationDeleteListSuccess: "Die bestehenden Artikel ({{guidList}}) wurden erfolgreich gelöscht.", // PMP
    inventoryUpdateArticleNotificationDeleteListError: "Die bestehenden Artikel ({{guidList}}) konnten nicht gelöscht werden.", // PMP
    inventoryUpdateArticleNotificationDeleteListUndefinedError: "Der bestehende Artikel konnte nicht gelöscht werden, da er nicht definiert ist.", // PMP

    // Inventory - Computer - general
    navComputer: 'Computerübersicht',
    tableComputer: 'Tabelle Computerübersicht',
    emptyPageTextComputer: 'Es sind noch keine Einträge für Computer erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Inventory - Computer - attributes label
    inventoryComputerTypeLabel: "Typ",
    inventoryComputerWLANLabel: "WLAN",
    inventoryComputerBluetoothLabel: "Bluetooth",
    inventoryComputerCellularLabel: "Mobilfunk",
    inventoryComputerDisplayLabel: "Monitor",
    inventoryComputerPowerConsumptionIdleLabel: "Leistungsaufnahme im Leerlauf",
    inventoryComputerPowerConsumptionFullLabel: "Leistungsaufnahme Volllast",
    inventoryComputerConnectionListLabel: "Anschlüsse",

    // Inventory - Computer - attributes tooltips
    inventoryComputerTypeToolTip: "Tooltip Typ",
    inventoryComputerWLANToolTip: "Tooltip WLAN",
    inventoryComputerBluetoothToolTip: "Tooltip Bluetooth",
    inventoryComputerCellularToolTip: "Tooltip Mobilfunk",
    inventoryComputerDisplayToolTip: "Tooltip Monitor",
    inventoryComputerPowerConsumptionIdleToolTip: "Tooltip Leistungsaufnahme im Leerlauf",
    inventoryComputerPowerConsumptionFullToolTip: "Tooltip Leistungsaufnahme Volllast",
    inventoryComputerConnectionListToolTip: "Tooltip Anschlüsse",

    // Inventory - Computer - attributes placeholder
    inventoryComputerTypePlaceholder: "Placeholder Typ",
    inventoryComputerWLANPlaceholder: "Placeholder WLAN",
    inventoryComputerBluetoothPlaceholder: "Placeholder Bluetooth",
    inventoryComputerCellularPlaceholder: "Placeholder Mobilfunk",
    inventoryComputerDisplayPlaceholder: "Placeholder Monitor",
    inventoryComputerPowerConsumptionIdlePlaceholder: "Placeholder Leistungsaufnahme im Leerlauf",
    inventoryComputerPowerConsumptionFullPlaceholder: "Placeholder Leistungsaufnahme Volllast",
    inventoryComputerConnectionListPlaceholder: "Placeholder Anschlüsse",

    inventoryCreateComputer: "Neuen Eintrag eines Computers erstellen",
    inventoryCreateComputerHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Computers für die Computerübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem inventory an.",
    inventoryCreateComputerHelpTextAfter: "Nach dem Speichern ist der erstellte Computer sofort in der Computerübersicht verfügbar.",

    inventoryUpdateComputer: "Bestehenden Eintrag eines Computers aktualisieren",
    inventoryUpdateComputerHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Computers für die Computerübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Computer an.",
    inventoryUpdateComputerHelpTextAfter: "Nach dem Speichern ist der erstellte Computer sofort in der Computerübersicht aktualisiert.",

    // Inventory - Computer - ConfirmationDialogComponent
    inventoryUpdateComputerCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Computers abbrechen wollen?",
    inventoryUpdateComputerUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Computer ({{guid}}) abbrechen wollen?",
    inventoryUpdateComputerDeleteConfirmation: "Sind Sie sicher, daß Sie den bestehenden Computer ({{guid}}) löschen wollen?",

    // Inventory - Computer - notifications
    inventoryUpdateComputerNotificationCreateCancel: "Das Erstellen eines neuen Computers wurde abgebrochen.",
    inventoryUpdateComputerNotificationCreateSuccess: "Der neue Computer wurde erfolgreich erstellt.",

    inventoryUpdateComputerNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Computers ({{guid}}) wurde abgebrochen.",
    inventoryUpdateComputerNotificationUpdateSuccess: "Der bestehende Computer ({{guid}}) wurde erfolgreich aktualisiert.",

    inventoryUpdateComputerNotificationDeleteSuccess: "Der bestehende Computer ({{guid}}) wurde erfolgreich gelöscht.",

    // Inventory - Display - general
    navDisplay: 'Monitorübersicht',
    tableDisplay: 'Tabelle Monitorübersicht',
    emptyPageTextDisplay: 'Es sind noch keine Einträge für Monitor erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Inventory - Display - attributes label
    inventoryDisplayColorLabel: "Farbe",
    inventoryDisplayDiagonalLabel: "Diagonale",
    inventoryDisplayImageFormatLabel: "Bildformat",
    inventoryDisplayResolutionLabel: "Auflösung",
    inventoryDisplayRefreshRateLabel: "Bildwiederholfrequenz",
    inventoryDisplayResponseTimeLabel: "Reaktionszeit",
    inventoryDisplayContrastLabel: "Kontrast",
    inventoryDisplayBrightnessLabel: "Helligkeit",
    inventoryDisplayShapeLabel: "Form",
    inventoryDisplayPanelLabel: "Panel",
    inventoryDisplayViewingAngleLabel: "Blickwinkel",
    inventoryDisplayPowerConsumptionLabel: "Leistungsaufnahme",
    inventoryDisplayConnectionListLabel: "Anschlüsse",

    // Inventory - Display - attributes tooltips
    inventoryDisplayColorToolTip: "Tooltip Farbe",
    inventoryDisplayDiagonalToolTip: "Tooltip Diagonale",
    inventoryDisplayImageFormatToolTip: "Tooltip Bildformat",
    inventoryDisplayResolutionToolTip: "Tooltip Auflösung",
    inventoryDisplayRefreshRateToolTip: "Tooltip Bildwiederholfrequenz",
    inventoryDisplayResponseTimeToolTip: "Tooltip Reaktionszeit",
    inventoryDisplayContrastToolTip: "Tooltip Kontrast",
    inventoryDisplayBrightnessToolTip: "Tooltip Helligkeit",
    inventoryDisplayShapeToolTip: "Tooltip Form",
    inventoryDisplayPanelToolTip: "Tooltip Panel",
    inventoryDisplayViewingAngleToolTip: "Tooltip Blickwinkel",
    inventoryDisplayPowerConsumptionToolTip: "Tooltip Leistungsaufnahme",
    inventoryDisplayConnectionListToolTip: "Tooltip Anschlüsse",

    // Inventory - Display - attributes placeholder
    inventoryDisplayColorPlaceholder: "Placeholder Farbe",
    inventoryDisplayDiagonalPlaceholder: "Placeholder Diagonale",
    inventoryDisplayImageFormatPlaceholder: "Placeholder Bildformat",
    inventoryDisplayResolutionPlaceholder: "Placeholder Auflösung",
    inventoryDisplayRefreshRatePlaceholder: "Placeholder Bildwiederholfrequenz",
    inventoryDisplayResponseTimePlaceholder: "Placeholder Reaktionszeit",
    inventoryDisplayContrastPlaceholder: "Placeholder Kontrast",
    inventoryDisplayBrightnessPlaceholder: "Placeholder Helligkeit",
    inventoryDisplayShapePlaceholder: "Placeholder Form",
    inventoryDisplayPanelPlaceholder: "Placeholder Panel",
    inventoryDisplayViewingAnglePlaceholder: "Placeholder Blickwinkel",
    inventoryDisplayPowerConsumptionPlaceholder: "Placeholder Leistungsaufnahme",
    inventoryDisplayConnectionListPlaceholder: "Placeholder Anschlüsse",

    inventoryCreateDisplay: "Neuen Eintrag eines Monitors erstellen",
    inventoryCreateDisplayHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Monitors für die Monitorübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem inventory an.",
    inventoryCreateDisplayHelpTextAfter: "Nach dem Speichern ist der erstellte Monitor sofort in der Monitorübersicht verfügbar.",

    inventoryUpdateDisplay: "Bestehenden Eintrag eines Monitors aktualisieren",
    inventoryUpdateDisplayHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Monitors für die Monitorübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Monitor an.",
    inventoryUpdateDisplayHelpTextAfter: "Nach dem Speichern ist der erstellte Monitor sofort in der Monitorübersicht aktualisiert.",

    // Inventory - Display - ConfirmationDialogComponent
    inventoryUpdateDisplayCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Monitors abbrechen wollen?",
    inventoryUpdateDisplayUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Monitor ({{guid}}) abbrechen wollen?",
    inventoryUpdateDisplayDeleteConfirmation: "Sind Sie sicher, daß Sie den bestehenden Monitor ({{guid}}) löschen wollen?",

    // Inventory - Display - notifications
    inventoryUpdateDisplayNotificationCreateCancel: "Das Erstellen eines neuen Monitors wurde abgebrochen.",
    inventoryUpdateDisplayNotificationCreateSuccess: "Der neue Monitor wurde erfolgreich erstellt.",

    inventoryUpdateDisplayNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Monitors ({{guid}}) wurde abgebrochen.",
    inventoryUpdateDisplayNotificationUpdateSuccess: "Der bestehende Monitor ({{guid}}) wurde erfolgreich aktualisiert.",

    inventoryUpdateDisplayNotificationDeleteSuccess: "Der bestehende Monitor ({{guid}}) wurde erfolgreich gelöscht.",

    // update ends here

    //TimeManager
    timeManagerTaskListFav: 'Markiert',
    timeManagerTaskListProj: 'Projekte',
    timeManagerTaskListRecent: 'Zuletzt verwendet',
    timeManagerTaskListAssigned: 'Zuweisung',
    timeManagerTaskListAll: 'Alle',
    timeManagerFavourite: 'Markierte Aufgaben',
    timeManagerNotFavourite: 'Unmarkierte Aufgaben',
    timeManagerLow: 'Niedrig',
    timeManagerModerate: 'Moderat',
    timeManagerHigh: 'Hoch',
    timeManagerNone: 'Keine',
    timeManagerAssignedToMe: 'An mich zugeteilt',
    timeManagerNotAssignedToMe: 'nicht an mich zugeteilt',
    timeManagerAll: 'Alle',
    timeManagerDisplayedCw: 'Angezeigte Kalender Woche:',
    timeManagerResetDate: 'Zur aktuellen Woche',
    timeManagerDndTable: 'Wochen Tabelle',
    timeManagerWeeklyTables: 'Erweiterte Wochen Tabelle',
    timeManagerWorkTime: 'Arbeitszeit',
    resetPermissionTooltip: "Setzt alle Berechtigungen auf Standardwerte zurück",
    notifyResetDone: "Standardberechtigungen wurden widerhergestellt",
    roleProjectManager: "PJM",
    roleProjectManagerTip: "Projekt-Manager",
    roleUser: "Benutzer",
    roleUserTip: "Standardbenutzer",
    roleHr: "HR",
    roleHrTip: "Human Resource - Manager",
    roleBookkeeper: "Bh",
    roleBookkeeperTip: "Buchhalter",
    roleFinancier: "FM",
    roleFinancierTip: "Finanz-Manager",
    roleOrderAndLicensing: "BLM",
    roleOrderAndLicensingTip: "Bestellung- & Lizenzierungs-Manager",
    roleInventoryManager: "Inv",
    roleInventoryManagerTip: "Inventar-Manager",
    roleProductManager: "PDM",
    roleProductManagerTip: "Produkt-Manager",
    userDetailsView: "Benutzer: {{username}}",
    userDetailsInfo: "Hier können Sie alle Benutzerinformationen einsehen und bearbeiten. Auch eine Rechtezuweisung ist möglich. Seien Sie sich über die möglichen Konsequenzen von Änderungen für den jeweiligen Benutzer bewusst.",
    userDetailsInfoTextAfter: "Nach dem Speichern wird der Benutzer sofort in Übersicht aktualisiert.",
    userSecurityInfo: "Hier können Sie alle Sicherheitsrelevanten Funktionen einsehen und ausführen. Seien Sie sich über die möglichen Konsequenzen von Änderungen für den jeweiligen Benutzer bewusst.",
    userSecurityInfoTextAfter: "Nach dem Speichern wird der Benutzer sofort in Übersicht aktualisiert.",
    userSecurityResetPw: "Passwort zurücksetzen",
    userSecurityLastPasswordChange: "Letzte Passwortänderung",
    userSecurityLockoutEnd: "Gesperrt bis",
    userSecurityLastLogin: "Letztes Login",
    userSecurityRegisteredSince: "Registriert seit",
    userSecurityIsActive: "Aktiv",
    general: "Allgemein",
    generalActive: "Aktiv",
    general_filter: "Filter",
    userSecurityPwSetSuccess: "Passwort erfolgreich gesetzt.",
    userSecurityLockUser: "Benutzer sperren",
    userSecurityLockAndUnlock: "Sperren & Freischalten",
    userSecurityUnlockUser: "Benutzer freischalten",
    userSecurityLockoutUserSuccess: "Benutzer erfolgreich gesperrt",
    userSecurityUnlockUserSuccess: "Benutzer erfolgreich freigeschaltet",
    userRolesInfo: "Hier können Sie alle Rechte einsehen und ändern. Seien Sie sich über die möglichen Konsequenzen von Änderungen für den jeweiligen Benutzer bewusst.",
    userRolesInfoTextAfter: "Nach dem Speichern wird der Benutzer sofort in der Übersicht aktualisiert.",
    userUpdatedSuccess: "Benutzer erfolgreich aktualisiert",
    paymentEditTitle: "Bankverbindung bearbeiten",
    paymentEditHelpTextPre: "Hier können Sie Ihre Bankverbindung einsehen und ändern. Auch Sicherheitsgründen werden nicht alle Informationen gezeigt. Sie können Die Bankverbindung dennoch aktualisieren.",
    paymentEditHelpTextAfter: "Nach dem Speichern wird die Bankverbindung sofort in der Übersicht aktualisiert.",
    projectHelpTextPre: "Hier können Sie Ihre Projektdetails einsehen und ändern.",
    projectHelpTextAfter: "Nach dem Speichern wird das Project sofort in der Übersicht aktualisiert.",
    projectTeamHelpTextPre: "Hier können Sie Ihr Projektteam einsehen und ändern. Seien Sie sich bewusst, dass Benutzern bei fehlzuweisung Zugriff auf sensitive Daten gewährt werden kann.",
    projectTeamHelpTextAfter: "Nach dem Speichern wird das Project sofort in der Übersicht aktualisiert.",
    sendInvoiceHelpTextPre: "Hier können Sie eine ausgewählte Rechnung <strong>{{InvoiceNum}}</strong> versenden und neben dem Kontakt <strong>{{ContactMail}}</strong> noch optionale Empänger hinzufügen.",
    sendInvoiceHelpTextAfter: "Stellen Sie zudem sicher, dass die eingetragenen Empfänger auch berechtigt sind Rechnungsinformationen einzusehen",
    sendInvoiceSuccess: "Die Rechnung '{{InvoiceNum}}' wurde erfolgreich gesendet.",
    helpTextBugTitle: "Hier einen sprechenden Titel für den Fehler vergeben",
    helpTextFrontendRoute: "Auf welcher Seite ist der Fehler aufgereten z.B. (/cp/home)",
    helpTextTicketType: "Was genau wird angemerkt?",
    helpTextDescription: "Beschreiben das konkrete Fehlerbild und deren Auswirkungen wenn möglich",
    helpTextStepToReproduce: "Schritt zum Reproduzieren (z.B. Klicke A, Sehe B)",
    stepsToReproduce: "Schritte zum Reproduzieren",
    stepToReproduceNr: "Schritt {{stepNo}}",
    bugTicketCreationSucceeded: "Ihr Ticket wurde erfolgreich erstellt",
    bugTicketCreationFailed: "Fehler beim erstellen Ihres Bugtickets. Bitte versuchen Sie es später erneut",
    userChangeRoleHint: "Benutzer können Ihre Rollen nicht selbst ändern. Kontaktieren Sie jemanden mit höheren Befugnissen.",
    ticketTypeBug: "Fehler",
    ticketTypeImprovement: "Optimierung",
    ticketTypeFeatureRequest: "Feature-Request",
    changeNewsPreviewImage: "Anzeigebild ändern",
    variableContext: "Kontext",
    variableValue: "Value",
    variableNameLabel: "Variable Name",
    variableNameToolTip: "Name der Variablen",
    variableNamePlaceholder: "Name der Variablen",
    variableContextLabel: "Variablen-Kontext",
    variableContextToolTip: "Kontext (Gruppe) der Variablen",
    variableContextPlaceholder: "Kontext (Gruppe) der Variablen",
    variableValueLabel: "Variablen-Wert",
    variableValueToolTip: "Wert (value) der Variablen",
    variableValuePlaceholder: "Wert (value) der Variablen",
    variableTypeLabel: "Variablen-Typ",
    variableTypeToolTip: "Datentyp der Variablen",
    variableTypePlaceholder: "Datentyp der Variablen",
    variableHelpTextPre: "In dem folgenden Formular können Sie den Wert einer einzelnen Variablen aktualisieren.",
    variableHelpTextAfter: "Variablen sind vom System vorgegeben und könnne nur eingesehen und aktualisiert werden. Das erstellen einer Varaiblen wird nur von den Entwicklern vorgenommen.",

    ///After this point adhere to the described standard!!!!!
    /// Translation keys shall conform to the specified format:
    /// {{module Name}}_{{component Name}}_{{meaning}}_{{usage}}
    /// module Name: name of the module in which the key will be used
    /// component Name: name of the component in which the key will be used
    /// meaning: what the key is intended to represent(e.g. login)
    /// usage: what the key will be used as (e.g. label, header, button)
    /// example: auth_login_resetPassword_link
    /// Exception:
    /// general use translation keys (e.g. save, cancel, continue, password,.....) shall fall under the module general and
    /// do not require a component
    /// example: general_save_button

    general_title:'Titel',
    general_name:'Name',
    general_user:'Nutzer',
    general_employee:'Mitarbeiter',
    general_firstName:'Vorname',
    general_lastName:'Nachname',
    general_email:'E-Mail',
    general_phone:'Telefon',
    general_mobile:'Mobil',
    general_address:'Adresse',
    general_country:'Land',
    general_federalState:'Bundesland',
    general_city:'Stadt',
    general_zipCodeShort:'PLZ',
    general_zipCode:'Postleitzahl',
    general_streetName:'Straßen Name',
    general_streetNumber:'Haus Nr.',
    general_company:'Firma',
    general_salutation:'Anrede',
    general_description:'Beschreibung',
    general_website:'Website',
    general_department:'Abteilung',
    general_save:'Speichern',
    general_delete:'Löschen',
    general_edit: "Bearbeiten",
    general_chooseState:'Wählen Sie den Status aus',
    general_create:'Erstellen',
    general_empty:'-- leer --',
    general_role:'Rolle',
    general_currentStatus:'Aktueller Status',
    general_contact:'Kontakte',
    general_project:'Projekt',
    general_excelImport:'Excel Importieren',
    general_index:'Index',
    general_startDate:'Startdatum',
    general_startTime:'Startzeit',
    general_endDate:'Enddatum',
    general_endTime:'Endzeit',
    general_hrsShort: "Std",
    general_clockSuffix: "Uhr",
    general_duration: "Dauer",
    general_none:'',
    general_pending:'Ausstehend',
    general_accepted:'Angenommen',
    general_rejected:'Abgelehnt',
    general_canceled:'Storniert',
    general_vacation:'Urlaub',
    general_sick:'Krank',
    general_timeOff:'Stundenausgleich',
    general_publicHolidays: 'Feiertage',
    general_publicHoliday: 'Feiertag',
    general_workTime:'Arbeitszeit',
    general_appointment:'Termin',
    general_specialLeave: 'Special Leave?',
    general_days: "Tage",
    general_day: "Tag",
    general_currentWorkflow: "Aktueller Workflow",
    general_backendId:'Backend Id',
    general_customerNumber: 'Kundennummer',
    general_phone_hint: 'Internationales Format: +49 123 456789',


    ///Controller
    //General
    controller_general_delete_success:'{{number}} {{entity}} erfolgreich gelöscht.',

    //Task
    controller_task_deleteSingleText_Label:'Sind sie sicher, dass sie eine Aufgabe löschen möchten?',
    controller_task_deleteMultiText_Label:'Sind sie sicher, dass sie {{number}} Aufgaben löschen möchten?',

    ///App
    //Navigation
    app_navigation_timeManagement_label:'Zeiterfassung',
    app_navigation_task_label:'Aufgaben',
    app_navigation_vacationManagement_label:'Abwesenheiten',
    app_navigation_vacationApproval_label:'Urlaubsanträge',

    ///crm
    //Company
    crm_company_basicInfo_tabLabel:'Grundlegende Infos',
    crm_company_addressInfo_tabLabel:'Adressen',
    crm_company_bankAccounts_tabLabel:'Bankkonten',
    crm_company_resource_tabLabel:'Ressourcen',
    crm_company_toResources_button:'Zu Ansicht Kontakte wechseln',

    //Task
    crm_task_taskName_label:'Aufgabe',
    crm_contract_customerFacingId_label:'Gesetzte ID',
    crm_contract_taskRisks_label:'Risiken',
    crm_contract_taskClarifications_label:'Klarstellungen',
    crm_contract_taskBudget_label:'Budget',
    crm_contract_taskCurrentEstimated_label:'Est.',
    crm_contract_connectedContacts_label:'Kontakte',
    crm_contract_taskCurrentStart_label:'Start',
    crm_contract_taskCurrentEnd_label:'Ende',
    crm_contract_taskEstimatedEffortSum_label:'Est. Aufwand Dauer',
    crm_contract_taskActualEffortSum_label:'Aufwand Dauer',
    crm_contract_category_label:'Kategorie',
    crm_task_currentStart_label:'Aktueller start',
    crm_task_currentEnd_label:'Aktuelles Ende',
    crm_task_currentEst_label:'Aktuell Abgeschätzt',
    crm_task_currentPlanned_label:'Aktuell Geplant',
    crm_task_effortTypes_label:'Aufwand Typen',
    crm_task_duration_label:'Est. Dauer',
    crm_task_actualDuration_label:'Dauer',
    crm_task_entityName:'Aufgaben',
    crm_task_details_sectionTitle:'Aufgaben Details',
    crm_task_id_label:'ID',
    crm_task_taskId_label:'Aufgaben-ID',
    crm_task_taskType_label:'Aufgabentyp',
    crm_task_mockup_label:'Mockups',
    crm_task_contact_label:'Kontakt',
    crm_task_references_label:'Referenzen',
    crm_task_originalStart_label:'Ursprünglicher Beginn',
    crm_task_originalEnd_label:'Ursprüngliches Ende',
    crm_task_originalEstimated_label:'Ursprüngliche Schätzung',
    crm_task_recentAppointments_label:'Letzte Termine',
    crm_contract_referencedTasks_label:'Referenzierte Aufgaben',
    crm_contract_referencedByTasks_label:'Referenziert Von',
    crm_contract_taskEffort_label:'Aufwände',

    //TaskEffort
    crm_taskEffort_effortName_label:'Aufwand',


    //Address Info
    crm_addressInfo_table_header:'Gespeicherte Adressen',
    crm_addressInfo_multiDelete_text:'Sind sie sicher ,dass sie {{number}} Kontakte löschen möchten?',

    //Projects
    crm_projects_addTeamMember_header:'Team-Mitglied hinzufügen',
    crm_projects_nextBill_tableHeader:'Nächste Rechnung',

    //Contacts
    crm_contacts_multiDelete_text:'Sind sie sicher dass sie {{number}} Kontakte löschen möchten?',
    crm_basicContactInfo_header_header:'Kontaktinformationen',
    crm_basicContactInfo_description_label:'Hier können sie Kontakt Informationen einsehen und ändern.',

    //Company
    crm_company_multiDelete_text:'Sind sie sicher dass sie {{number}} Firmen löschen möchten?',

    ///Resource Manager
    //Human Resources
    resourceManager_humanResources_noTaskOnProject_label:'Diesem Projekt wurden bisher keine Aufgaben zugwiesen.',
    resourceManager_humanResources_addTask_label:'Neue Aufgaben für dieses Projekt erstellen',

    partialViews_dialog_calendarExport_header: "Leistungsnachweis Exportieren",
    resourceManager_calendarExport_users_label:'Benutzer auswählen',
    resourceManager_calendarExport_summary_title:'Export Zusammenfassung',
    resourceManager_calendarExport_currentUserFallback_label:'Aktueller Benutzer',
    resourceManager_calendarExport_usersSelected_label:'Benutzer ausgewählt',
    resourceManager_calendarExport_invalidRange_label:'Das Enddatum muss nach dem Startdatum liegen.',
    resourceManager_calendarExport_missingCustomerAddress_label:'Für den Kunden ist keine Adresse hinterlegt.',
    resourceManager_calendarExport_project_label:'Projekt',
    resourceManager_calendarExport_separateFiles_label:'Je Mitarbeiter eine eigene PDF erzeugen',
    resourceManager_calendarExport_separateFiles_hint:'Bei mehreren ausgewählten Mitarbeitern wird ein ZIP mit separaten Leistungsnachweisen heruntergeladen.',
    resourceManager_calendarExport_outputMode_label:'Ausgabe',
    resourceManager_calendarExport_outputMode_singleFile_label:'Eine gemeinsame PDF',
    resourceManager_calendarExport_outputMode_separateFiles_label:'Separate PDFs je Mitarbeiter',


    //TimeTracker
    resourceManager_timeTracker_onPageLeave_label:'Sie haben ungespeicherte einträge!',
    resourceManager_timeTracker_dismiss_label:'Änderungen Verwerfen',
    resourceManager_timeTracker_saveUnused_label:'Ungespeicherte einträge Speichern',
    resourceManager_timeTracker_returnToCurrentWeek_button:'Zur aktuellen Woche',
    resourceManager_timeTracker_currentWeek_label:'Kalender Woche',
    resourceManager_timeTracker_currentViewed_label:'Aktueller Mitarbeiter',
    resourceManager_timeTracker_taskListAll_label:'Alle',
    resourceManager_timeTracker_openOvertime_label:'Überstunden',

    //CalendarStatistics
    resourceManager_calendarStatistic_yearStats_tabHeader: 'Jährliche Statistiken',
    resourceManager_calendarStatistic_weekStats_tabHeader: 'Wöchentliche Statistiken',

    resourceManager_calendarStatistic_weeklyTargetHours_label: 'Wochenstunden',

    resourceManager_calendarStatistic_vacationDaysEntitled_label: 'Urlaubstage pro Jahr',
    resourceManager_calendarStatistic_vacationDaysTaken_label: 'Genommene Urlaubstage bisher',
    resourceManager_calendarStatistic_vacationDaysPlanned_label: 'Geplante Urlaubstage',
    resourceManager_calendarStatistic_vacationDaysAvailableNow_label: 'Urlaub aktuell verfügbar',
    resourceManager_calendarStatistic_vacationCarryOver_label: 'Urlaubübertrag aktuell verfügbar',
    resourceManager_calendarStatistic_vacationCarryOverDeadlineNext_label: 'Nächstes Verfallsdatum Urlaubübertrag',

    resourceManager_calendarStatistic_sickDaysTaken_label: 'Krankheitstage bisher',

    resourceManager_calendarStatistic_overtimeAvailableNow_label: 'Überstundenstand aktuell',
    resourceManager_calendarStatistic_overtimeRawCurrentYear_label: 'Überstunden dieses Jahr',
    resourceManager_calendarStatistic_overtimeCarryOver_label: 'Überstundenübertrag aktuell verfügbar',
    resourceManager_calendarStatistic_overtimeCarryOverDeadlineNext_label: 'Nächstes Verfallsdatum Überstundenübertrag',

    resourceManager_calendarStatistic_expectedHours_label: 'Sollstunden',
    resourceManager_calendarStatistic_adjustedExpectedHours_label:'Sollstunden mit Überstundenstand',
    resourceManager_calendarStatistic_overtimeBalanceBeforeWeek_label:'Überstundenstand vor Wochenbeginn',
    resourceManager_calendarStatistic_workedHours_label: 'Geleistete Stunden',
    resourceManager_calendarStatistic_sickDays_label: 'Krankheitstage',
    resourceManager_calendarStatistic_absenceCreditHours_label: 'Abwesenheitsgutschrift in Stunden',
    resourceManager_calendarStatistic_overtimeHours_label: 'Überstunden',
    resourceManager_calendarStatistic_remainingHours_label: 'Verbleibende Stunden',

    resourceManager_projectStatistics_budget_tabTitle: "Budget",
    resourceManager_projectStatistics_budget_tabName: "Budget",
    resourceManager_projectStatistics_years_tabTitle: "Jahre",
    resourceManager_projectStatistics_years_tabName: "Jahre",
    resourceManager_projectStatistics_users_tabTitle: "Mitarbeiter",
    resourceManager_projectStatistics_users_tabName: "Mitarbeiter",
    resourceManager_projectStatistics_filter_label: "Anzeige",
    resourceManager_projectStatistics_refresh_button: "Aktualisieren",
    resourceManager_projectStatistics_projects_statLabel: "Projekte",
    resourceManager_projectStatistics_totalBudget_statLabel: "Budget gesamt",
    resourceManager_projectStatistics_openBudget_statLabel: "Budget offen",
    resourceManager_projectStatistics_plannedHours_statLabel: "Geplante Stunden",
    resourceManager_projectStatistics_actualHours_statLabel: "Ist Stunden",
    resourceManager_projectStatistics_deltaHours_statLabel: "Delta",
    resourceManager_projectStatistics_filter_all_option: "Alle Projekte",
    resourceManager_projectStatistics_filter_open_option: "Nur offenes Budget",
    resourceManager_projectStatistics_filter_worked_option: "Nur mit Ist Stunden",
    resourceManager_projectStatistics_totalBudget_label: "Budget gesamt",
    resourceManager_projectStatistics_openBudget_label: "Budget offen",
    resourceManager_projectStatistics_usedBudget_label: "Verbraucht",
    resourceManager_projectStatistics_plannedHours_label: "Geplante Stunden",
    resourceManager_projectStatistics_actualHours_label: "Ist Stunden",
    resourceManager_projectStatistics_deltaHours_label: "Delta",
    resourceManager_projectStatistics_budgetUsage_label: "Budgetverbrauch",
    resourceManager_projectStatistics_userName_header: "Name",
    resourceManager_projectStatistics_userPlannedHours_header: "Geplante Stunden",
    resourceManager_projectStatistics_userActualHours_header: "Ist Stunden",
    resourceManager_projectStatistics_year_header: "Jahr",
    resourceManager_projectStatistics_appointments_header: "Appointments",
    resourceManager_projectStatistics_worklogs_header: "Worklogs",
    resourceManager_projectStatistics_yearPlannedHours_header: "Geplant",
    resourceManager_projectStatistics_yearActualHours_header: "Ist",
    resourceManager_projectStatistics_yearDeltaHours_header: "Delta",
    resourceManager_projectStatistics_customer_columnLabel: "Kunde",
    resourceManager_projectStatistics_project_columnLabel: "Projekt",
    resourceManager_projectStatistics_totalBudget_columnLabel: "Budget gesamt",
    resourceManager_projectStatistics_openBudget_columnLabel: "Budget offen",
    resourceManager_projectStatistics_plannedHours_columnLabel: "Geplante Stunden",
    resourceManager_projectStatistics_actualHours_columnLabel: "Ist Stunden",
    resourceManager_projectStatistics_deltaHours_columnLabel: "Delta",
    resourceManager_projectStatistics_teamMembers_columnLabel: "Teammitglieder",
    resourceManager_projectStatistics_tasks_columnLabel: "Tasks",
    resourceManager_projectStatistics_coverageFrom_columnLabel: "Abdeckung von",
    resourceManager_projectStatistics_coverageTo_columnLabel: "Abdeckung bis",
    resourceManager_projectStatistics_table_label: "Projektstatistik",
    resourceManager_projectStatistics_noYears_label: "Keine Jahresstatistik verfügbar",
    resourceManager_projectStatistics_noUsers_label: "Keine Mitarbeiterstatistiken verfügbar",
    resourceManager_projectStatistics_period_label: "Zeitraum",
    resourceManager_projectStatistics_period_all_option: "Alle Jahre",
    resourceManager_projectStatistics_period_year_option: "Ein Jahr",

    //bannerItem
    resourceManager_bannerItem_halfDay_label:'1/2 {{type}}',

    //VacationManagement
    resourceManager_vacationManager_vacationStats_header:'Bisherige Abwesenheiten im gewählten Jahr',
    resourceManager_vacationManager_addNewEntry_header:'Neue Abwesenheit hinzufügen',
    resourceManager_vacationManager_filterView_label: 'Typ',
    resourceManager_vacationManager_save_tooltip: 'Abwesenheit speichern',
    resourceManager_vacationManager_save_disabled_tooltip: 'Bitte Start, Ende und Typ prüfen, bevor gespeichert werden kann.',

    //AbsenceManager
    resourceManager_absenceManager_personalView_lable:'Einzelansicht',
    resourceManager_absenceManager_generalView_lable:'Firmenansicht',
    resourceManager_absenceOverview_resetYear_label:'Zum Aktuellen Jahr',
    resourceManager_absenceOverview_currentYear_label:'Aktuelles Jahr',

    //VacationApproved
    resourceManager_vacationApproved_application_header:'Urlaubsanträge',
    resourceManager_vacationApproved_pending_label:'Offen',
    resourceManager_vacationApproved_history_label:'Historie',
    resourceManager_vacationApproved_viewSelect_label:'Ansicht Auswahl',
    resourceManager_vacationApproved_rejectAll_button:'Alle ausgewählte Anfragen ablehnen',
    resourceManager_vacationApproved_approveAll_button:'Alle ausgewählte Anfragen annehmen',
    resourceManager_vacationApproved_durationInDay_label:'Urlaubsdauer in Tagen',
    resourceManager_vacationApproved_decisionStatus_label:'Entscheidungsstatus',
    resourceManager_vacationApproved_decidedBy_label:'Entschieden von',
    resourceManager_vacationApproved_decidedAt_label:'Entschieden am',
    resourceManager_vacationApproved_reason_label:'Grund',
    resourceManager_vacationApproved_decisionComment_label:'Entscheidungskommentar',
    resourceManager_vacationApproved_decisionStatus_None_label:'',
    resourceManager_vacationApproved_decisionStatus_Pending_label:'Ausstehend',
    resourceManager_vacationApproved_decisionStatus_Accepted_label:'Angenommen',
    resourceManager_vacationApproved_decisionStatus_Rejected_label:'Abgelehnt',
    resourceManager_vacationApproved_decisionStatus_Cancelled_label:'Zurückgezogen',
    resourceManager_vacationApproved_withdraw_text:'Sind Sie sicher, dass Sie diesen ausstehenden Antrag zurückziehen möchten?',
    resourceManager_vacationApproved_cancel_text:'Sind Sie sicher, dass Sie diesen genehmigten Antrag stornieren möchten?',
    resourceManager_vacationApproved_multiDelete_text:'Sind sie sicher dass sie {{number}} Anträge ablehnen möchten?',
    resourceManager_vacationApproved_delete_text: "Sind sie sicher dass sie den Antrag löschen möchten?",

    ///Partial Views
    //Dialog
    //Confirmation
    partialViews_dialog_confirmationDefaultText_label:'Sind sie sicher?',
    partialViews_dialog_confirmationDefaultNo_button:'Nein',
    partialViews_dialog_confirmationDefaultYes_button:'Ja',

    //TimeManagerEntry
    partialViews_dialog_addTimeEntry_header:'Arbeitszeit buchen',

    ///Formulars
    //Project Team Formular
    formular_projectTeam_helpText_text:'Hier können Sie Ihr Projektteam einsehen und ändern. Seien Sie sich bewusst, dass Benutzern bei Fehlzuweisung Zugriff auf sensitive Daten gewährt werden kann.\nNach dem Speichern wird das Project sofort in der Übersicht aktualisiert.',

    //Bank Account Formular
    formular_bankAccount_table_title:'Gespeicherte Bank Konten',
    formular_bankAccount_accountOwner_label:'Konto Besitzer',
    formular_bankAccount_bankName_label:'Bankname',
    formular_bankAccount_iban_label:'IBan',
    formular_bankAccount_bic_label:'BIC',
    formular_bankAccount_billingAccountOnly_label:'Nur Rechnungskonto',
    formular_bankAccount_default_label:'Standard Konto',
    formular_bankAccount_multiDelete_text:'Sind sie sicher dass sie {{number}} Konten löschen möchten?',
    formular_bankAccount_iban_hint: 'z.B. DE89 3704 0044 0532 0130 00',
    formular_bankAccount_bic_hint: 'z.B. COBADEFFXXX',


    general_save_button: 'Speichern',
    general_cancel_button: 'Abbrechen',
    general_comingSoon_label: 'Demnächst verfügbar',

    account_account_eyebrow_label: 'Konto',
    account_account_title_header: 'Mein Konto',
    account_account_description_text: 'Persönliche Einstellungen, Sicherheit, Integrationen und individuelle Arbeitsbereich Optionen.',

    account_account_profileStat_label: 'Profil',
    account_account_profileStat_complete_value: 'Vollständig',
    account_account_profileStat_incomplete_value: 'Unvollständig',
    account_account_profileStat_complete_hint: 'Ihr Profil ist vollständig ausgefüllt.',
    account_account_profileStat_incomplete_hint: 'Ihr Profil ist noch nicht vollständig ausgefüllt.',
    account_account_profileStat_hint: 'Stammdaten gepflegt',

    account_account_integrationsStat_label: 'Integrationen',
    account_account_integrationsStat_value: '{{count}} aktiv',
    account_account_integrationsStat_hint: 'Aktive Verbindungen',

    account_account_securityStat_label: 'Sicherheit',
    account_account_securityStat_value: '{{count}} Hinweis',
    account_account_securityStat_hint: 'Empfohlene Prüfungen',

    account_account_accountSection_header: 'Konto',
    account_account_accountSection_text: 'Persönliche Daten und grundlegende Kontoinformationen',

    account_account_personalData_header: 'Persönliche Daten',
    account_account_personalData_text: 'Name, Kontakt und Stammdaten bearbeiten',
    account_account_personalData_status_badge: 'Aktuell',
    account_accountPersonalData_recommendations_header: 'Profil Hinweise',
    account_accountPersonalData_recommendations_text: '{{count}} Punkte sollten ergänzt werden.',

    account_accountSecurity_recommendations_header: 'Sicherheit Hinweise',
    account_accountSecurity_recommendations_text: '{{count}} Empfehlungen sind offen.',

    account_account_companyRole_header: 'Firma und Rolle',
    account_account_companyRole_text: 'Zugeordnete Firma und Rollenübersicht ansehen',

    account_account_securitySection_header: 'Sicherheit',
    account_account_securitySection_text: 'Zugriff, Authentifizierung und persönliche Tokens',

    account_account_passwordLogin_header: 'Passwort und Anmeldung',
    account_account_passwordLogin_text: 'Passwort ändern und aktive Sitzungen prüfen',
    account_account_passwordLogin_status_badge: 'Empfehlung',

    account_account_apiTokens_header: 'API Tokens',
    account_account_apiTokens_text: 'Persönliche API Zugriffe verwalten',
    account_account_apiTokens_status_badge: 'Deaktiviert',

    account_account_integrationsSection_header: 'Integrationen',
    account_account_integrationsSection_text: 'Persönliche Verbindungen mit externen Diensten',

    account_account_calendar_header: 'Kalender',
    account_account_calendar_text: 'Google, Outlook oder ICS verbinden',
    account_account_calendar_status_badge: 'Verbunden',
    account_account_calendar_meta: '{{count}} aktiv',

    account_account_mail_header: 'E Mail',
    account_account_mail_text: 'Persönliche Mail Integrationen verwalten',

    account_accountPersonalData_eyebrow_label: 'Konto',
    account_accountPersonalData_title_header: 'Persönliche Daten',
    account_accountPersonalData_description_text: 'Pflege deine persönlichen Stammdaten und Kontaktdetails.',
    account_accountPersonalData_back_button: 'Zurück zu Mein Konto',
    account_accountPersonalData_masterData_header: 'Stammdaten',
    account_accountPersonalData_masterData_text: 'Name, Kontakt und weitere persönliche Angaben',

    // account security
    account_accountSecurity_eyebrow_label: 'Konto',
    account_accountSecurity_title_header: 'Passwort und Sicherheit',
    account_accountSecurity_description_text: 'Verwalten Sie Ihr Passwort und prüfen Sie sicherheitsrelevante Einstellungen Ihres Kontos.',
    account_accountSecurity_back_button: 'Zurück zu Mein Konto',

    account_accountSecurity_changePassword_button: 'Passwort ändern',

    account_accountSecurity_passwordPanel_header: 'Passwort ändern',
    account_accountSecurity_passwordPanel_text: 'Ändern Sie Ihr aktuelles Passwort für dieses Konto.',

    account_accountSecurity_email_label: 'E-Mail',
    account_accountSecurity_currentPassword_label: 'Aktuelles Passwort',
    account_accountSecurity_newPassword_label: 'Neues Passwort',
    account_accountSecurity_newPasswordConfirm_label: 'Neues Passwort bestätigen',

    account_accountSecurity_currentPasswordRequired_error: 'Bitte geben Sie Ihr aktuelles Passwort ein.',
    account_accountSecurity_newPasswordRequired_error: 'Bitte geben Sie ein neues Passwort ein.',
    account_accountSecurity_newPasswordLength_error: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
    account_accountSecurity_newPasswordConfirmRequired_error: 'Bitte bestätigen Sie das neue Passwort.',
    account_accountSecurity_passwordMismatch_error: 'Die neuen Passwörter stimmen nicht überein.',

    account_accountSecurity_success_text: 'Ihr Passwort wurde erfolgreich geändert.',
    account_accountSecurity_error_text: 'Das Passwort konnte nicht geändert werden. Bitte prüfen Sie Ihre Eingaben.',

    account_accountSecurity_notesPanel_header: 'Hinweise',
    account_accountSecurity_notesPanel_text: 'Wichtige Informationen zur Passwortänderung.',
    account_accountSecurity_noteOne_text: 'Nach einer erfolgreichen Änderung erhalten Sie eine Bestätigungs-E-Mail.',
    account_accountSecurity_noteTwo_text: 'Falls Sie Ihr aktuelles Passwort nicht mehr kennen, verwenden Sie den Passwort-zurücksetzen-Workflow auf der Anmeldeseite.',

    // account calendar integrations
    general_refresh_button: 'Aktualisieren',
    general_test_button: 'Testen',
    general_disconnect_button: 'Trennen',
    general_connect_button: 'Verbinden',

    account_accountCalendar_eyebrow_label: 'Integrationen',
    account_accountCalendar_title_header: 'Kalender',
    account_accountCalendar_description_text: 'Verbinden Sie externe Kalender und verwalten Sie Synchronisationen.',
    account_accountCalendar_back_button: 'Zurück zu Mein Konto',

    account_accountCalendar_overview_header: 'Übersicht',
    account_accountCalendar_overview_text: 'Status der Kalender Integrationen auf einen Blick.',
    account_accountCalendar_overviewIntegrations_label: 'Integrationen',
    account_accountCalendar_overviewSources_label: 'Ausgewählte Quellen',
    account_accountCalendar_overviewProviders_label: 'Anbieter',

    account_accountCalendar_existing_header: 'Verbundene Kalender',
    account_accountCalendar_existing_text: 'Bestehende Integrationen testen, synchronisieren oder bearbeiten.',
    account_accountCalendar_noIntegrations_text: 'Es sind aktuell keine Kalender Integrationen verbunden.',
    account_accountCalendar_connectedSources_text: '{{count}} Quellen verbunden',
    account_accountCalendar_lastSync_text: 'Letzte Synchronisation',

    account_accountCalendar_newIntegration_button: 'Neue Integration',
    account_accountCalendar_sync_button: 'Synchronisieren',
    account_accountCalendar_manageSources_button: 'Quellen verwalten',

    account_accountCalendar_providerSelection_header: 'Anbieter wählen',
    account_accountCalendar_providerSelection_text: 'Wählen Sie zuerst den Kalenderanbieter und vervollständigen Sie anschließend die jeweilige Einrichtung.',
    account_accountCalendar_supported_badge: 'Unterstützt',

    account_accountCalendar_providerIcs_header: 'ICS',
    account_accountCalendar_providerIcs_text: 'Kalender über eine ICS URL verbinden.',
    account_accountCalendar_providerIcsSetup_text: 'Geben Sie die ICS URL und optional Zugangsdaten an.',
    account_accountCalendar_providerIcsAbo: 'ICS abonnieren',
    account_accountCalendar_providerIcsUpload: 'ICS Datei importieren',

    account_accountCalendar_providerMicrosoft_header: 'Microsoft',
    account_accountCalendar_providerMicrosoft_text: 'Microsoft Kalender per OAuth verbinden.',
    account_accountCalendar_providerMicrosoftSetup_text: 'Richten Sie die Microsoft Verbindung ein und starten Sie anschließend den OAuth Flow.',

    account_accountCalendar_providerGoogle_header: 'Google',
    account_accountCalendar_providerGoogle_text: 'Google Kalender per OAuth verbinden.',
    account_accountCalendar_providerGoogleSetup_text: 'Richten Sie die Google Verbindung ein und starten Sie anschließend den OAuth Flow.',

    account_accountCalendar_providerUnknown_label: 'Kalenderanbieter',

    account_accountCalendar_displayName_label: 'Anzeigename',
    account_accountCalendar_icsUrl_label: 'ICS URL',
    account_accountCalendar_icsUsername_label: 'Benutzername',
    account_accountCalendar_icsPassword_label: 'Passwort',
    account_accountCalendar_tenantHint_label: 'Tenant Hinweis',
    account_accountCalendar_oAuthClientId_label: 'OAuth Client Id',
    account_accountCalendar_oAuthClientSecret_label: 'OAuth Client Secret',

    account_accountCalendar_importAppointments_label: 'Termine importieren',
    account_accountCalendar_importAbsences_label: 'Abwesenheiten importieren',
    account_accountCalendar_exportAbsences_label: 'Abwesenheiten exportieren',

    account_accountCalendar_createIntegration_button: 'Integration erstellen',

    account_accountCalendar_sources_header: 'Kalenderquellen',
    account_accountCalendar_sources_text: 'Wählen Sie die Kalender aus, die für diese Integration verwendet werden sollen.',
    account_accountCalendar_noSources_text: 'Es wurden keine Kalenderquellen gefunden.',
    account_accountCalendar_refreshSources_button: 'Quellen neu laden',
    account_accountCalendar_saveSources_button: 'Auswahl speichern',
    account_accountCalendar_sourcesSaved_text: 'Die Quellenauswahl wurde gespeichert.',
    account_accountCalendar_readOnly_label: 'Nur Lesen',
    account_accountCalendar_primary_label: 'Primärer Kalender',
    account_accountCalendar_unsubscribeSource_button: 'Quelle abbestellen',
    account_accountCalendar_removeSource_button: 'Quelle entfernen',

    account_accountCalendar_oAuthSuccess_text: 'Die OAuth Verbindung wurde erfolgreich abgeschlossen.',
    account_accountCalendar_oAuthStateMismatch_text: 'Die OAuth Anmeldung konnte nicht verifiziert werden.',
    account_accountCalendar_oAuthProviderMissing_text: 'Der Anbieter für die OAuth Rückkehr konnte nicht bestimmt werden.',
    account_accountCalendar_icsCreateSuccess_text: 'Die ICS Integration wurde erstellt.',
    account_accountCalendar_genericError_text: 'Die Kalender Integration konnte nicht verarbeitet werden.',

    account_accountCalendar_providerIcsUploadInfo_text: 'Einmaliger ICS Dateiimport. Dieser Flow erstellt keine permanente Kalender Integration.',
    account_accountCalendar_providerIcsUploadFile_label: 'ICS Datei auswählen',
    account_accountCalendar_providerIcsUploadNoFile_text: 'Noch keine Datei gewählt',
    account_accountCalendar_skipDuplicates_label: 'Duplikate überspringen',
    account_accountCalendar_splitOverlappingEntries_label: 'Überlappungen aufteilen',
    account_accountCalendar_dryRun_label: 'Nur simulieren, nichts speichern',
    account_accountCalendar_resetSelection_button: 'Auswahl zurücksetzen',
    account_accountCalendar_previewLoad_button: 'Vorschau laden',
    account_accountCalendar_importExecute_button: 'Import ausführen',
    account_accountCalendar_importFile_label: 'Datei',
    account_accountCalendar_importEntries_label: 'Einträge',
    account_accountCalendar_importWarnings_label: 'Warnungen',
    account_accountCalendar_importPreview_header: 'ICS Vorschau',
    account_accountCalendar_importPreview_text: 'Zusammenfassung aus dem Preview Endpoint',
    account_accountCalendar_importPeriod_label: 'Zeitraum',
    account_accountCalendar_importFrom_label: 'Von',
    account_accountCalendar_importTo_label: 'Bis',
    account_accountCalendar_importCreated_label: 'Erstellt',
    account_accountCalendar_importUpdated_label: 'Aktualisiert',
    account_accountCalendar_importSkipped_label: 'Übersprungen',
    account_accountCalendar_importConflicts_label: 'Konflikte',
    account_accountCalendar_importHints_header: 'Import Hinweise',
    account_accountCalendar_importHints_text: 'Rückmeldungen aus dem Commit Endpoint',
    account_accountCalendar_importFileMissing_text: 'Bitte zuerst eine ICS Datei auswählen.',
    account_accountCalendar_importPreviewSuccess_text: 'ICS Vorschau erfolgreich geladen.',
    account_accountCalendar_importCommitSuccess_text: 'ICS Datei erfolgreich importiert.',
    account_accountCalendar_importDryRunSuccess_text: 'ICS Import Dry Run erfolgreich ausgeführt.',

    rmCalendarNoTasksInProject: "Dieses Projekt erfordert Aufgaben, hat aber noch keine. Bitte legen Sie zunächst Aufgaben für das Projekt an",
    rmCalendarNoTasksSelect: "Für dieses Projekt ist eine Aufgabe erforderlich. Bitte wählen Sie einen Task aus",


    // administration page
    administration_eyebrow_label: 'Administration',
    administration_title_header: 'Verwaltung',
    administration_description_text: 'Zentrale Übersicht für Kontodaten, Zugriffe, Servereinstellungen, Variablen und Integrationen.',
    administration_back_button: 'Zurück zum Dashboard',

    administration_sectionsStat_label: 'Bereiche',
    administration_sectionsStat_hint: 'Verfügbare Verwaltungsbereiche',
    administration_routesStat_label: 'Ziele',
    administration_routesStat_value: '{{count}} Einträge',
    administration_routesStat_hint: 'Direkt erreichbare Verwaltungsseiten',
    administration_comingSoonStat_label: 'Geplant',
    administration_comingSoonStat_value: '{{count}} offen',
    administration_comingSoonStat_hint: 'Bereiche mit geplanter Erweiterung',

    administration_sectionAccount_text: 'Stammdaten, Adressen und Zahlungsinformationen verwalten.',
    administration_sectionDiagnostics_text: 'Systemzustand, Logs und spätere Monitoring Bereiche.',
    administration_sectionAccess_text: 'Rollen, Rechte und Benutzerzuordnungen steuern.',
    administration_sectionServer_text: 'Umgebung und datenbankbezogene Servereinstellungen.',
    administration_sectionVariables_text: 'Systemweite Variablen und Konfigurationen verwalten.',
    administration_sectionIntegrations_text: 'Externe Systeme und Kommunikationswege anbinden.',

    administration_company_text: 'Unternehmensstammdaten und Kontoinformationen.',
    administration_addresses_text: 'Standorte, Rechnungs und Kontaktadressen verwalten.',
    administration_payment_text: 'Zahlungswege und Abrechnungsinformationen bearbeiten.',

    administration_logs_label: 'Logs',
    administration_logs_text: 'Protokolle, Ereignisse und technische Fehlerausgaben.',
    administration_health_label: 'Health',
    administration_health_text: 'Überblick über Systemzustand und Verfügbarkeiten.',
    administration_stats_label: 'Statistiken',
    administration_stats_text: 'Servermetriken, Nutzung und Diagnosewerte.',

    administration_roles_text: 'Rollen definieren und administrieren.',
    administration_permissions_text: 'Rechte und Rollenzuweisungen verwalten.',
    administration_userRoles_text: 'Benutzer, Rollen und Zuständigkeiten abstimmen.',
    administration_api_label: 'API',
    administration_api_text: 'Technische Schnittstellen und Zugriffstoken.',

    administration_environment_text: 'Umgebungswerte und technische Konfiguration prüfen.',
    administration_backup_text: 'Sicherung, Wiederherstellung und Datenbankoperationen.',
    administration_variables_text: 'Systemvariablen zentral verwalten.',
    administration_mailClients_label: 'E Mail Clients',
    administration_mailClients_text: 'Mail Anbindungen und Versandkanäle konfigurieren.',

    "company_oauthSettings_title_header": "OAuth Einstellungen",
    "company_oauthSettings_description_text": "OAuth Zugänge für Google und Microsoft auf Firmenebene verwalten",

    "company_oauthSettings_providerGoogle_header": "Google Kalender",
    "company_oauthSettings_providerGoogle_text": "OAuth Daten für Google Kalender Verbindungen",
    "company_oauthSettings_providerGoogle_hint": "Diese Daten werden als Standard für Google Kalender Integrationen der Firma verwendet.",

    "company_oauthSettings_providerMicrosoft_header": "Microsoft 365 Kalender",
    "company_oauthSettings_providerMicrosoft_text": "OAuth Daten für Microsoft 365 Kalender Verbindungen",
    "company_oauthSettings_providerMicrosoft_hint": "Diese Daten werden als Standard für Microsoft Kalender Integrationen der Firma verwendet.",

    "company_oauthSettings_enabled_label": "Provider aktiv",
    "company_oauthSettings_allowOverride_label": "Benutzer Override erlauben",

    "company_oauthSettings_tenant_label": "Tenant oder Tenant Hint",
    "company_oauthSettings_tenant_placeholder": "z. B. common oder Tenant ID",

    "company_oauthSettings_clientId_label": "Client ID",
    "company_oauthSettings_clientId_placeholder": "OAuth Client ID",

    "company_oauthSettings_clientSecret_label": "Client Secret",
    "company_oauthSettings_clientSecret_placeholder": "OAuth Client Secret",
    "company_oauthSettings_clientSecretKeep_placeholder": "Leer lassen, um das vorhandene Secret zu behalten",

    "company_oauthSettings_redirectUri_label": "Redirect URI",
    "company_oauthSettings_redirectUri_placeholder": "https://app.example.com/oauth/callback",

    "administration_oauthSettings_label": "OAuth Einstellungen",
    "administration_oauthSettings_text": "Google und Microsoft OAuth Konfiguration für Integrationen verwalten"

}